   <template>
    <div class="make-bid-document-page">
      <div class="page-shell">
        <aside class="left-sidebar">
          <div class="sidebar-header">
            <div>
              <h2 class="sidebar-title">投标文件制作台</h2>
            </div>
          </div>
          <div class="project-summary-card">
            <div class="ca-status-header">
              <div>
                <h3 class="ca-status-title">CA 登录管理</h3>
              </div>
              <el-tag :type="caLoggedIn ? 'success' : 'info'" size="mini">
                {{ caLoggedIn ? '已登录' : '未登录' }}
              </el-tag>
            </div>
            <div class="ca-status-row">
              <span>当前用户</span>
              <strong>{{ currentCaUserName || '未识别' }}</strong>
            </div>
            <!-- <div v-if="bidKeyInfo && bidKeyInfo.secretKey" class="ca-status-row">
            <span>锁状态</span>
            <strong>{{ symKey ? '已解锁' : '待解锁' }}</strong>
          </div>
          <div v-if="bidKeyInfo && bidKeyInfo.secretKey" class="ca-lock-panel">
            <div class="ca-lock-line">锁证书ID：{{ bidKeyInfo.caKeyId || bidKeyInfo.cakeyId || '-' }}</div>
            <div class="ca-lock-line">锁证书名称：{{ bidKeyInfo.caKeyName || '-' }}</div>
            <el-button size="small" type="danger" :loading="keyUnlockLoading" @click="handleUnlockBidKey">解锁</el-button>
          </div> -->
            <el-select v-model="caForm.certId" class="ca-user-select" size="small" filterable clearable
              placeholder="请选择 CA 用户" :loading="isLoadingCert" @change="handleCAUserChange">
              <el-option v-for="item in certList" :key="item.certid" :label="item.name || item.certid"
                :value="item.certid" />
            </el-select>
            <div class="ca-action-group">
              <el-button size="small" type="primary" :loading="caLoading" @click="handleCALogin">CA 登录</el-button>
            </div>
            <div class="ca-action-group">
              <el-button size="small" type="warning" :loading="caLogoutLoading" @click="handleCALogout">退出
                CA</el-button>
              <el-button size="small" type="success" :loading="caSwitchLoading" @click="handleCASwitch">切换
                CA</el-button>
            </div>
            <div class="ca-action-group">
              <el-button size="small" type="primary" @click="registerCA">CA 注册</el-button>
            </div>
          </div>
          <el-menu :default-active="activeMenu" class="document-menu" :unique-opened="true" @select="handleMenuSelect">
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-document-copy"></i>
                <span>招标文件</span>
              </template>
              <el-menu-item index="1-1">正文概览</el-menu-item>
              <el-menu-item index="1-2">附件资料</el-menu-item>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-s-order"></i>
                <span>开标一览表</span>
              </template>
              <el-menu-item index="2-1">报价信息</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-folder-opened"></i>
                <span>投标附件</span>
              </template>
              <el-menu-item index="3-1">附件</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-notebook-2"></i>
                <span>投标正文</span>
              </template>
              <el-menu-item index="4-1">{{ Number(isBlindReview) === 1 ? '明标正文' : '正文' }}</el-menu-item>
              <el-menu-item v-if="Number(isBlindReview) === 1" index="4-2">暗标正文</el-menu-item>
            </el-submenu>
          </el-menu>
          <div class="encrypt-btn" @click="handleEncryptClick">
            <i class="el-icon-lock"></i>
            <span>加密文件</span>
          </div>
        </aside>
        <main class="right-content">
          <section class="content-panel">
            <div class="single-template-card">
              <div class="card-header-row">
                <div>
                  <div class="menu-display-chip">当前菜单</div>
                  <h2 class="menu-display-title">{{ currentPanel.title }}</h2>
                  <p class="menu-display-desc">{{ currentPanel.description }}</p>
                </div>
              </div>
              <div v-if="activeMenu === '1-1'" class="pdf-preview-panel">
                <div v-if="invitationMainUrl" class="pdf-viewer-container">
                  <div class="pdf-viewer-toolbar">
                    <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownloadPdf">
                      下载正文
                    </el-button>
                    <el-button type="primary" size="small" icon="el-icon-document" @click="handleDownloadWord"
                      v-if="invitationWordUrl">
                      下载文件正文(word)
                    </el-button>
                  </div>
                  <PdfViewer :pdf-url="invitationMainUrl" :show-toolbar="true" :initial-scale="1" />
                </div>
                <div v-else class="template-placeholder">
                  <div class="placeholder-icon">
                    <i class="el-icon-document"></i>
                  </div>
                  <div class="placeholder-text">
                    <strong>暂无正文文件</strong>
                    <span>当前标段暂未获取到投标文件正文 PDF。</span>
                  </div>
                </div>
              </div>
              <div v-else-if="activeMenu === '1-2'" class="attachment-panel">
                <el-table :data="formattedInvitationAttList" class="attachment-table">
                  <el-table-column prop="fileName" label="文件名称"></el-table-column>
                  <el-table-column prop="fileExtension" label="格式"></el-table-column>
                  <el-table-column prop="fileSizeText" label="大小"></el-table-column>
                  <el-table-column label="下载地址">
                    <template slot-scope="scope">
                      <a :href="scope.row.fileUrl" target="_blank" class="file-link">下载文件</a>
                    </template>
                  </el-table-column>
                </el-table>
                <div v-if="!formattedInvitationAttList.length" class="template-placeholder">
                  <div class="placeholder-icon">
                    <i class="el-icon-folder-opened"></i>
                  </div>
                  <div class="placeholder-text">
                    <strong>暂无附件</strong>
                    <span>当前标段暂未获取到投标文件正文附件列表。</span>
                  </div>
                </div>
              </div>

              <div v-else-if="activeMenu === '2-1'" class="content-panel">
                <div class="panel-header-actions">
                  <h3 class="content-title">开标一览表</h3>
                  <el-button type="primary" size="small" @click="handleOpeningSummarySave">保存</el-button>
                </div>
                <div class="content-body">
                  <el-table :data="openingSummaryList" style="width: 100%">
                    <el-table-column prop="itemKey" label="序号" align="center" width="60" />
                    <el-table-column prop="itemName" label="名称" />
                    <el-table-column prop=" /** 填报内容类型（0：任意文本、1：纯数字） */" label="数值类型">
                      <template slot-scope="scope">
                        <span v-if="scope.row.itemValueType == 0">任意文本</span>
                        <span v-if="scope.row.itemValueType == 1">纯数字</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="内容">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.itemValue"
                          :placeholder="isCapitalRequired(scope.row.itemName) ? '请输入中文大写' : scope.row.itemValueType == 1 ? '请输入数字' : '请输入内容'"
                          @input="handleItemValueInput(scope.row, scope.$index)" />
                      </template>
                    </el-table-column>
                    <el-table-column prop="itemUnit" label="单位">
                      <template slot-scope="scope">
                        <span v-if="scope.row.itemUnit == 0">元</span>
                        <span v-if="scope.row.itemUnit == 1">万元</span>
                        <span v-if="scope.row.itemUnit == 2">%</span>
                        <span v-if="scope.row.itemUnit == null">-</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="itemType" label="类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.itemType == 1">总价</span>
                      <span v-if="scope.row.itemType == 2">费率</span>
                      <span v-if="scope.row.itemType == 3">单价</span>
                      <span v-if="scope.row.itemType == 9">其他</span>
                      <span v-if="scope.row.itemType == 0">文本内容</span>
                      <span v-if="scope.row.itemType == 6">工期</span>
                    </template>
                  </el-table-column> -->
                    <el-table-column prop="remark" label="备注" min-width="120" />
                  </el-table>
                </div>
              </div>
              <!-- 投标附件 3-1 -->
              <div v-else-if="activeMenu === '3-1'" class="bid-att-panel">
                <div class="upload-section">
                  <div class="panel-header-actions">
                    <h4 class="section-title">投标附件加密</h4>
                    <el-button type="primary" size="small" icon="el-icon-folder-opened" @click="selectBidAttFilePath">选择附件文件</el-button>
                  </div>
                  <div class="el-upload__tip">附件可多次选择添加；每个附件使用 CA 控件选择本地路径后单独加密。</div>
                </div>
                <div v-if="attEncryptList.length" class="pending-files">
                  <h4 class="section-title">待加密附件 ({{ attEncryptList.length }})</h4>
                  <el-table :data="attEncryptList" class="pending-att-table">
                    <el-table-column label="附件路径" min-width="260">
                      <template slot-scope="scope">
                        <div class="file-name-cell">
                          <i :class="getFileIcon(scope.row.fileName)"></i>
                          <span :title="scope.row.filePath">{{ scope.row.filePath }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="状态" width="120">
                      <template slot-scope="scope">
                        <el-tag size="mini" :type="scope.row.encryptSuccess ? 'success' : 'info'">
                          {{ scope.row.uploadSuccess ? '已上传' : (scope.row.encryptSuccess ? '已加密' : '待加密') }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="360">
                      <template slot-scope="scope">
                        <el-button type="text" :loading="scope.row.encrypting" @click="encryptBidAttFile(scope.row)">加密</el-button>
                        <el-button v-if="scope.row.encryptSuccess" type="text" @click="copyFolderPath(scope.row.outFilePath)">复制密文文件夹</el-button>
                        <el-upload v-if="scope.row.encryptSuccess" class="inline-upload hide-file-list" action="#"
                          :auto-upload="false" :show-file-list="false" accept=".enc"
                          :on-change="file => handleEncryptedBidAttBrowserFileChange(file, scope.row)">
                          <el-button type="text">上传文件</el-button>
                        </el-upload>
                        <el-button type="text" class="danger-text" @click="removeBidAttEncryptItem(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="上传文件" min-width="160">
                      <template slot-scope="scope">
                        <span>{{ scope.row.encryptedFileName || '-' }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-if="bidAttList.length" class="existing-files">
                  <h4 class="section-title">已上传附件</h4>
                  <el-table :data="bidAttList" class="bid-att-table">
                    <el-table-column prop="fileName" label="文件名称"></el-table-column>
                    <el-table-column prop="fileSize" label="大小(K)"></el-table-column>
                    <el-table-column prop="fileExtension" label="格式"></el-table-column>
                    <el-table-column label="操作" width="120">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" @click="downloadAndDecryptAtt(scope.row)">下载</el-button>
                        <el-button type="text" size="small" @click="deleteAndDecryptAtt(scope.row)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <!-- 投标正文 4-1 -->
              <div v-else-if="activeMenu === '4-1' || activeMenu === '4-2'" class="bid-main-panel">
                <!-- 正文加载进度条：非阻塞，展示在面板顶部 -->
                <div v-if="mainLoadProgress.visible" class="main-load-progress-bar">
                  <div class="main-load-progress-info">
                    <i class="el-icon-loading"></i>
                    <span class="main-load-progress-text">{{ mainLoadProgress.text }}</span>
                  </div>
                  <el-progress :percentage="mainLoadProgress.percent" :stroke-width="6" :show-text="false"
                    :indeterminate="mainLoadProgress.indeterminate" :duration="3" status="success" />
                </div>
                <div class="main-preview-section">
                  <div class="preview-header">
                    <h4 class="section-title">
                      <template v-if="currentMainState.pendingMainFile">
                        <el-tag type="primary" size="mini" style="margin-right: 8px;">待上传</el-tag>{{ currentMainLabel }}
                      </template>
                      <template v-else-if="currentMainState.bidMainUrl">
                        <el-tag type="success" size="mini" style="margin-right: 8px;">已加密</el-tag>{{ currentMainLabel }}
                      </template>
                      <template v-else>待上传{{ currentMainLabel }}</template>
                    </h4>
                    <div v-if="activeMenu !== '4-2' && !hasUploadedCurrentMain" class="preview-actions">
                      <el-button type="primary" size="small" icon="el-icon-folder-opened" @click="selectOpenMainPdfPath">
                        {{ currentMainState.mainFilePath ? '重新选择PDF' : '选择PDF文件' }}
                      </el-button>
                      <el-tag v-if="currentMainState.mainFilePath" type="info" size="small" style="max-width:300px;overflow:hidden;text-overflow:ellipsis;">{{ currentMainState.mainFilePath }}</el-tag>
                      <!-- <el-button type="primary" size="small" icon="el-icon-check"
                        @click="handleBidMainSave">保存</el-button>
                      <el-button type="success" size="small" icon="el-icon-download" @click="downloadBidMain">{{ currentMainLabel }}下载</el-button> -->
                    </div>
                  </div>
                  <div v-if="activeMenu === '4-2' && !hasUploadedCurrentMain" class="blind-encrypt-card">
                    <div class="blind-encrypt-icon">
                      <i class="el-icon-lock"></i>
                    </div>
                    <h4>暗标正文加密</h4>
                    <p>暗标正文不进行页面预览，请通过 CA 控件选择本地文件后再执行加密。</p>
                    <div class="blind-file-row">
                      <el-button type="primary" icon="el-icon-folder-opened" @click="selectBlindMainFilePath">选择暗标正文文件</el-button>
                      <el-tag v-if="currentMainState.mainFilePath" type="info" size="small">{{ currentMainState.mainFilePath }}</el-tag>
                    </div>
                  </div>
                  <div v-if="!hasUploadedCurrentMain" class="main-file-encrypt-form workflow-encrypt-form">
                    <!-- 路径一：在线加密后上传 -->
                    <div class="encrypt-row">
                      <el-button type="danger" size="small" icon="el-icon-lock" :loading="mainFileEncrypting"
                        @click="handleBidMainFileEncrypt">{{ activeMenu === '4-2' ? '加密暗标文件' : '加密明标文件' }}</el-button>
                      <el-button v-if="currentMainState.mainEncryptSuccess" size="small"
                        @click="copyFolderPath(currentMainState.mainOutFilePath)">复制密文文件夹</el-button>
                      <el-upload v-if="currentMainState.mainEncryptSuccess" class="hide-file-list" action="#"
                        :auto-upload="false" :show-file-list="false" accept=".enc"
                        :on-change="handleEncryptedBidMainBrowserFileChange">
                        <el-button type="primary" size="small" icon="el-icon-upload2">上传加密结果</el-button>
                      </el-upload>
                      <el-tag v-if="currentMainState.mainEncryptResult" size="small"
                        :type="currentMainState.mainEncryptSuccess ? 'success' : 'danger'">
                        {{ currentMainState.mainEncryptResult }}
                      </el-tag>
                    </div>
                    <!-- 分隔线 -->
                    <div class="encrypt-divider"><span>或</span></div>
                    <!-- 路径二：已有加密文件，直接上传 -->
                    <div class="encrypt-row">
                      <el-upload class="hide-file-list" action="#"
                        :auto-upload="false" :show-file-list="false" accept=".enc"
                        :on-change="handleEncryptedBidMainBrowserFileChange">
                        <el-button size="small" icon="el-icon-upload2">直接上传已有加密文件</el-button>
                      </el-upload>
                      <el-tag v-if="currentMainState.encryptedMainFilePath" size="small" type="info">
                        已选择：{{ currentMainState.encryptedMainFilePath }}
                      </el-tag>
                    </div>
                  </div>
                  <div v-if="hasUploadedCurrentMain" class="existing-files">
                    <h4 class="section-title">已加密正文</h4>
                    <el-table :data="[currentMainState.bidMainFileInfo]" class="bid-att-table">
                      <el-table-column label="文件名称">
                        <template slot-scope="scope">
                          {{ scope.row.fileName || currentMainLabel }}
                        </template>
                      </el-table-column>
                      <el-table-column label="状态" width="120">
                        <template>
                          <el-tag type="success" size="mini">已加密</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                          <el-button type="text" size="small" @click="downloadBidMainEncrypted(scope.row)">下载</el-button>
                          <el-button type="text" size="small" style="color: #f56c6c;"
                            @click="deleteBidMainEncrypted(scope.row)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="main-pdf-viewer">
                    <div class="pdf-chapters" v-if="activeMenu !== '4-2' && mainPdfDisplayUrl">
                      <div class="chapter-header">
                        <div class="chapter-header-left">
                          <i class="el-icon-document-copy chapter-icon"></i>
                          <span class="chapter-title">文件目录</span>
                        </div>
                        <span class="chapter-count-badge">{{ catalogueList.length }}</span>
                      </div>
                      <el-tree class="catalogue-tree" :data="catalogueList" :props="catalogueProps" node-key="strId"
                        default-expand-all highlight-current @node-click="handleCatalogueClick">
                        <span slot-scope="{ node, data }" class="custom-tree-node">
                          <i class="node-type-icon"
                            :class="node.childNodes && node.childNodes.length ? 'el-icon-folder' : 'el-icon-document'"></i>
                          <span class="catalogue-node-title" :title="data.catalogueName">{{ data.catalogueName }}</span>
                          <span class="node-meta">
                            <el-tag v-if="data.pageNum" class="catalogue-node-tag" size="mini" effect="plain">第{{
                              data.pageNum
                              }}页</el-tag>
                            <el-button type="text" size="mini" class="catalogue-node-action"
                              @click.stop="bindCataloguePage(data)">
                              {{ data.pageNum ? '修改' : '关联' }}
                            </el-button>
                          </span>
                        </span>
                      </el-tree>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="template-placeholder">
                <div class="placeholder-icon">
                  <i class="el-icon-document"></i>
                </div>
                <div class="placeholder-text">
                  <strong>{{ currentPanel.title }}</strong>
                  <span>这里保留为通用模板展示区域，仅显示当前选中的菜单名称。</span>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>

      <div v-if="showUnlockOverlay" class="unlock-overlay">
        <div class="unlock-overlay-card">
          <div class="unlock-overlay-icon">🔒</div>
          <h2>检测到投标文件已加锁</h2>
          <p>请先使用对应 CA 证书完成解锁，解锁前无法继续后续操作。</p>
          <div class="unlock-overlay-info">
            <div class="unlock-overlay-line">
              <span>锁证书ID</span>
              <strong>{{ bidKeyInfo.caKeyId || bidKeyInfo.cakeyId || '-' }}</strong>
            </div>
            <div class="unlock-overlay-line">
              <span>锁证书名称</span>
              <strong>{{ bidKeyInfo.caKeyName || '-' }}</strong>
            </div>
            <div class="unlock-overlay-divider"></div>
            <div class="unlock-overlay-line">
              <span>当前选中的CA名称</span>
              <strong>{{ getSelectedCADisplayName() }}</strong>
            </div>
            <div class="unlock-overlay-line">
              <span>当前选中的CA ID</span>
              <strong>{{ getSelectedCADisplayId() }}</strong>
            </div>
          </div>
          <div v-if="unlockStepText" class="unlock-step-panel" :class="`is-${unlockStepStatus}`">
            <span class="unlock-step-label">解锁步骤</span>
            <strong>{{ unlockStepText }}</strong>
          </div>
          <div class="unlock-overlay-actions">
            <el-button size="medium" type="primary" :loading="caLoading" @click="handleCALogin">CA 登录</el-button>
            <el-button size="medium" type="warning" :loading="caLogoutLoading" @click="handleCALogout">CA 登出</el-button>
            <el-button size="medium" type="danger" :loading="keyUnlockLoading"
              @click="handleUnlockBidKey">立即解锁</el-button>
          </div>
        </div>
      </div>

      <!-- 文件预览弹窗 -->
      <el-dialog :visible.sync="previewVisible" :title="previewTitle" width="80%" top="5vh" append-to-body
        @close="closePreview">
        <div class="preview-container">
          <!-- PDF 预览 -->
          <iframe v-if="previewUrl && previewTitle.endsWith('.pdf')" :src="previewUrl" class="preview-frame"
            frameborder="0"></iframe>
          <!-- 图片预览 -->
          <img v-else-if="previewUrl && isImageFile(previewTitle)" :src="previewUrl" class="preview-image" />
          <!-- 其他文件提示 -->
          <div v-else class="preview-not-supported">
            <i class="el-icon-warning-outline"></i>
            <p>该文件类型不支持在线预览，请下载后查看</p>
            <a :href="previewUrl" :download="previewTitle" class="download-link">
              <el-button type="primary">下载文件</el-button>
            </a>
          </div>
        </div>
      </el-dialog>
    </div>
  </template>

<script>
import { getBidMain, deleteBidMain, getOneTimeToken, getOneTimeUrl, getBidAttList, deleteBidAtt, uploadBidSign, uploadBidAtt, saveKeyInfo, getInvitationMain, getInvitationAttList, getOpeningSummaryList, addOpeningSummary, getBidKeyInfo, getInvitationCatalogue, getBidCatalogue, finishBidMake } from '@/api/modules/make'
import PdfViewer from '@/components/common/PdfViewer.vue'
import { XTXASynObject } from '@/api/ca/XTXASynObject'
import { useStore } from '@/api/ca/store/index'
import { makeBidDocumentFileMethods } from '@/utils/makeBidDocumentFileUtils'
import { getSectionBaseInfo, downloadInvitation } from '@/api/modules/base'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
const DEFAULT_SIGN_SAVE_DIR = 'C:\\BJCAROOT\\pawdocs\\PDFClient'
const ENCRYPT_OUT_DIR = 'C:\\FakePath'
const SIGN_STORAGE_KEY = 'caLocalSignPdfData'
const SIGN_RESULT_KEY = 'caLocalSignResult'
const BID_MAIN_SIGN_DRAFT_KEY = 'bidMainSignDraft'
const BID_MAIN_SIGN_KEEP_STATE_KEY = 'bidMainSignKeepState'

export default {
  components: { PdfViewer },
  name: 'MakeBidDocument',
  data() {
    return {
      keyInfo: null,
      bidKeyInfo: null,
      activeMenu: '1-1',
      projectInfo: {
        sectionCode: this.$route.query.sectionCode,
      },
      invitationMainUrl: '',
      invitationWordUrl: '', // 招标文件正文 Word 下载地址
      invitationAttList: [],
      openingSummaryList: [],
      // 投标文件相关数据
      bidAttList: [], // 已上传的投标附件列表
      bidMainUrl: '', // 已上传的投标正文URL
      catalogueList: [],
      catalogueProps: {
        children: 'children',
        label: 'catalogueName'
      },
      currentBidPage: 1,
      currentMainPdfLoadedUrl: '',
      openingSummarySavedSnapshot: '',
      mainFileEncrypting: false,
      pendingAttFiles: [], // 待上传的附件文件（本地缓存）
      attEncryptList: [],
      mainDocStates: {
        open: {
          bidMainUrl: '',
          bidMainFileInfo: {},
          pendingMainFile: null,
          previewMainUrl: '',
          sourcePdfPath: '',
          mainFilePath: '',
          mainOutFilePath: '',
          encryptedMainFilePath: '',
          mainEncryptResult: '',
          mainEncryptSuccess: false,
          currentMainPdfLoadedUrl: '',
          pdfBase64: '',
          signedFilePath: '',
          signedPreviewUrl: '',
          signedPdfFileName: ''
        },
        blind: {
          bidMainUrl: '',
          bidMainFileInfo: {},
          pendingMainFile: null,
          previewMainUrl: '',
          sourcePdfPath: '',
          mainFilePath: '',
          mainOutFilePath: '',
          encryptedMainFilePath: '',
          mainEncryptResult: '',
          mainEncryptSuccess: false,
          currentMainPdfLoadedUrl: '',
          pdfBase64: '',
          signedFilePath: '',
          signedPreviewUrl: '',
          signedPdfFileName: ''
        }
      },
      // 预览相关
      previewVisible: false,
      previewUrl: '',
      previewTitle: '',
      // 投标文件签章相关数据
      bidSignList: [], // 已上传的签章文件列表
      pendingSignFiles: [], // 待上传的签章文件（本地缓存）
      // CA相关数据
      xtxObject: null,
      caStore: null,
      certList: [], // 证书列表
      caForm: {
        certId: '',
        passWd: '111111'
      },
      defaultCaCertId: 'MSSPDefaultContainer/msspDev000000000000000000',
      caLoading: false,
      isLoadingCert: false,
      caStatusLoading: false,
      caLogoutLoading: false,
      caSwitchLoading: false,
      caLoggedIn: false,
      currentCaUserName: '',
      keyUnlockLoading: false,
      unlockStepText: '',
      unlockStepStatus: 'idle',
      // 非对称加解密表单
      asymForm: {
        cert: '', // 加密证书(Exchange)
        plain: '', // 原文
        cipher: '', // 密文
        decrypted: '', // 解密后明文
        base64Out: true
      },
      asymLoading: {
        encrypt: false,
        decrypt: false
      },
      // 对称密钥
      symKey: '',
      isBlindReview: 0,
      isSaving: false,
      mainPdfReading: false,
      // 文件绑定ID（同一次保存批次共享，用于关联本次上传的正文/附件）
      fileBindId: Date.now().toString(),
      // 正文加载进度（非阻塞，展示在面板顶部）
      mainLoadProgress: {
        visible: false,
        text: '',
        percent: 0,
        indeterminate: false
      }
    }
  },
  computed: {
    currentPanel() {
      const panelMap = {
        '1-1': { title: '招标文件正文概览', description: '' },
        '1-2': { title: '招标文件附件资料', description: '' },
        '2-1': { title: '开标一览表概览', description: '' },
        '3-1': { title: '投标附件整理区', description: '' },
        '4-1': { title: Number(this.isBlindReview) === 1 ? '明标正文' : '投标正文', description: '' },
        '4-2': { title: '暗标正文', description: '' },
        '5': { title: '加密文件', description: '点击进行开标一览表加密操作' }
      }
      return panelMap[this.activeMenu] || panelMap['1-1']
    },
    currentMainState() {
      return this.currentMainBlindFlag === 1 ? this.mainDocStates.blind : this.mainDocStates.open
    },
    currentMainBlindFlag() {
      if (Number(this.isBlindReview) !== 1) {
        return 0
      }
      return this.activeMenu === '4-2' ? 1 : 0
    },
    currentMainLabel() {
      if (Number(this.isBlindReview) !== 1) {
        return '投标正文'
      }
      return this.activeMenu === '4-2' ? '暗标正文' : '明标正文'
    },
    hasUploadedCurrentMain() {
      return !!(this.currentMainState.bidMainUrl && !this.currentMainState.pendingMainFile)
    },
    // 投标正文展示URL：仅展示本地选择/签章预览，已上传加密正文不做 PDF 回显
    mainPdfDisplayUrl() {
      if (this.currentMainState.previewMainUrl) return this.currentMainState.previewMainUrl
      return ''
    },
    formattedInvitationAttList() {
      return this.invitationAttList.map(item => ({
        ...item,
        fileSizeText: this.formatFileSize(item.fileSize)
      }))
    },
    showUnlockOverlay() {
      return !!(this.bidKeyInfo && this.bidKeyInfo.secretKey && !this.symKey)
      // return false
    }
  },
  created() {
    // 初始化CA对象
    this.xtxObject = new XTXASynObject()
    this.caStore = useStore()
  },
  mounted() {
    this.getSectionBaseInfo()
    this.downloadInvitation()
    this.checkBidMainSignResult()
  },
  beforeDestroy() {
    Object.keys(this.mainDocStates || {}).forEach(key => {
      const state = this.mainDocStates[key]
      if (state.previewMainUrl) {
        URL.revokeObjectURL(state.previewMainUrl)
      }
      if (state.signedPreviewUrl) {
        URL.revokeObjectURL(state.signedPreviewUrl)
      }
    })
  },
  methods: {

    /******** ----------------页面初始化与基础信息----------------- ********/
    // 通过一次性 token 把 fileId 解析为可访问的下载/预览 URL
    async resolveFileUrlByOneTime(fileId) {
      if (!fileId) return ''
      try {
        const tokenRes = await getOneTimeToken(fileId)
        if (!tokenRes || tokenRes.code !== 200 || !tokenRes.data) {
          console.warn('[oneTime] 获取一次性 token 失败:', tokenRes)
          return ''
        }
        const urlRes = await getOneTimeUrl(tokenRes.data)
        if (!urlRes || urlRes.code !== 200 || !urlRes.data) {
          console.warn('[oneTime] 获取一次性 url 失败:', urlRes)
          return ''
        }
        return urlRes.data
      } catch (error) {
        console.error('[oneTime] 解析文件地址异常:', error)
        return ''
      }
    },




    async downloadInvitation() {
      const res = await downloadInvitation(this.projectInfo.sectionCode)
      if (res.code == 200) {
        this.invitationWordUrl = res.data || ''
      }
    },
    handleDownloadWord() {
      if (!this.invitationWordUrl) {
        console.log();

        this.$message.warning('暂无招标文件正文 Word 文件可下载')
        return
      }
      const link = document.createElement('a')
      link.href = this.invitationWordUrl
      link.target = '_blank'
      link.download = '招标文件正文.docx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },


    async getSectionBaseInfo() {
      const res = await getSectionBaseInfo(this.projectInfo.sectionCode)
      if (res.code == 200) {
        this.isBlindReview = res.data.isBlindReview
        this.initHttp()
      } else {
        this.initHttp()
      }
    },
    initHttp() {
      const stateRestored = this.restorePageStateAfterSign()
      this.loadInvitationMain()
      this.loadInvitationAttList()
      this.initCertList(stateRestored)
      if (!stateRestored) {
        this.getBidKeyInfo()
      } else if (this.symKey) {
        // 签章返回时 symKey 已从 sessionStorage 恢复，直接用它加载开标一览表
        this.loadOpeningSummaryList()
      }
      this.bidAttList = []
      this.loadInvitationCatalogue()
    },

    async autoUploadAfterSign() {
      this.$message.info('正文加解密上传逻辑已移除')
    },

    /******** ----------------CA注册、外部文件方法----------------- ********/
    registerCA() {
      window.open('https://online.bjca.org.cn/v2/#/index/indexNew?channelId=PT1nTjRnak13QVRN', '_blank')
    },
    ...makeBidDocumentFileMethods,

    /******** ----------------CA密钥与解锁相关----------------- ********/
    // 解密从接口获取的secretKey
    async decryptSecretKey(encryptedKey) {
      try {
        // 解密必须使用实际已登录的 certId（私钥需要已认证才能使用）
        let certId = this.caForm.certId
        try {
          const lastLoginId = await this.xtxObject.SOF_GetLastLoginCertID()
          if (lastLoginId) certId = lastLoginId
        } catch (e) { /* ignore, fallback to caForm.certId */ }
        console.log('------解密信息');
        console.log(certId);
        console.log(encryptedKey);
        console.log('------解密信息');

        const plainKey = await this.xtxObject.SOF_PriKeyDecrypt(certId, encryptedKey)
        return plainKey
      } catch (error) {
        console.error('解密对称密钥失败:', error)
        return null
      }
    },
    async handleUnlockBidKey() {
      if (!this.bidKeyInfo || !this.bidKeyInfo.secretKey) {
        this.$message.warning('当前没有待解锁的密钥信息')
        return false
      }
      if (!this.checkCALogin()) return false
      this.keyUnlockLoading = true
      this.unlockStepStatus = 'loading'
      this.unlockStepText = '投标一览表：正在解密'
      try {
        const plainKey = await this.decryptSecretKey(this.bidKeyInfo.secretKey)
        if (!plainKey) {
          this.unlockStepStatus = 'error'
          this.unlockStepText = '投标一览表：解密失败'
          this.$message.error('解锁失败，请确认当前登录证书是否与锁信息一致')
          return false
        }
        this.symKey = plainKey
        this.unlockStepStatus = 'loading'
        this.unlockStepText = '投标一览表：正在加载'
        await this.loadOpeningSummaryList()
        this.unlockStepStatus = 'success'
        this.unlockStepText = '投标一览表：解密成功'
        this.$message.success('解锁成功')
        return true
      } catch (error) {
        console.error('手动解锁失败:', error)
        this.unlockStepStatus = 'error'
        this.unlockStepText = '投标一览表：解密失败'
        this.$message.error('解锁失败：' + (error.message || '未知错误'))
        return false
      } finally {
        this.keyUnlockLoading = false
      }
    },
    checkBidKeyUnlocked(showMessage = true) {
      if (this.symKey) {
        return true
      }
      if (this.bidKeyInfo && this.bidKeyInfo.secretKey) {
        if (showMessage) {
          this.$message.warning('检测到已存在锁信息，请先点击解锁后再继续操作')
        }
        return false
      }
      return true
    },
    syncLockedCertSelection() {
      const lockCertId = this.bidKeyInfo?.caKeyId || this.bidKeyInfo?.cakeyId
      const lockCertName = this.bidKeyInfo?.caKeyName
      if (!lockCertId || !Array.isArray(this.certList) || this.certList.length === 0) {
        if (!lockCertName || !Array.isArray(this.certList) || this.certList.length === 0) {
          return
        }
      }
      let matchedUser = this.certList.find(item => item.certid === lockCertId)
      if (!matchedUser && lockCertName) {
        matchedUser = this.certList.find(item => item.name === lockCertName)
      }
      if (matchedUser) {
        this.caForm.certId = matchedUser.certid
        this.currentCaUserName = matchedUser.name || ''
      }
    },
    getCachedCAUser() {
      try {
        const cached = localStorage.getItem('makeBidDocumentSelectedCAUser')
        return cached ? JSON.parse(cached) : null
      } catch (error) {
        console.warn('读取缓存 CA 证书失败:', error)
        return null
      }
    },
    cacheCurrentCAUser() {
      if (!this.caForm.certId) {
        return
      }
      try {
        localStorage.setItem('makeBidDocumentSelectedCAUser', JSON.stringify({
          certId: this.caForm.certId,
          name: this.currentCaUserName || ''
        }))
      } catch (error) {
        console.warn('缓存 CA 证书失败:', error)
      }
    },

    /******** ----------------开标一览表密钥初始化----------------- ********/
    //获取密钥
    async getBidKeyInfo() {
      const res = await getBidKeyInfo(this.projectInfo.sectionCode)
      if (res.code == 200) {
        this.keyInfo = res.data
        if (res.data !== null) {
          if (res.data.secretKey == null) {
            await this.loadOpeningSummaryList()
          }
          this.bidKeyInfo = res.data
          this.symKey = ''
          this.syncLockedCertSelection()
        } else {
          this.bidKeyInfo = null
          this.symKey = ''
          // 仅在 CA 已登录时才尝试生成密钥并验证密钥对，避免页面初始化时未登录就报错
          if (this.caLoggedIn) {
            await this.getSymKeySilent()
            if (this.symKey) {
              try {
                await this.exportExchangeCert(this.caForm.certId)
                const usable = await this.verifyKeyPairUsable()
                if (!usable) {
                  this.symKey = ''
                  this.bidKeyInfo = null
                  this.$message.error('当前 CA 证书加密/私钥不匹配（可能是单位锁/个人锁不一致），请切换正确的 CA 后重试')
                } else if (this.asymForm.cert) {
                  const cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.symKey)
                  if (cipher) {
                    this.bidKeyInfo = { secretKey: cipher }
                  }
                }
              } catch (e) {
                console.error('密钥加密失败:', e)
              }
            }
          }
          this.loadOpeningSummaryList()
        }
      }
    },
    // CA登录后自动获取密钥信息，不自动解密（需用户手动解锁）
    async getBidKeyInfoAndDecrypt() {
      try {
        const res = await getBidKeyInfo(this.projectInfo.sectionCode)
        if (res.code == 200 && res.data !== null) {
          this.bidKeyInfo = res.data
          this.symKey = ''
          this.syncLockedCertSelection()
        } else {
          this.bidKeyInfo = null
          this.symKey = ''
          await this.getSymKeySilent()
          if (this.symKey) {
            try {
              await this.exportExchangeCert(this.caForm.certId)
              const usable = await this.verifyKeyPairUsable()
              if (!usable) {
                this.symKey = ''
                this.bidKeyInfo = null
                this.$message.error('当前 CA 证书加密/私钥不匹配（可能是单位锁/个人锁不一致），请切换正确的 CA 后重试')
              } else if (this.asymForm.cert) {
                const cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.symKey)
                if (cipher) {
                  this.bidKeyInfo = { secretKey: cipher }
                }
              }
            } catch (e) {
              console.error('密钥加密失败:', e)
            }
          }
          await this.loadOpeningSummaryList()
        }
      } catch (error) {
        console.error('获取密钥信息失败:', error)
        await this.loadOpeningSummaryList()
      }
    },

    /******** ----------------招标文件正文与附件展示----------------- ********/
    // 加载招标文件正文
    async loadInvitationMain() {
      if (!this.projectInfo.sectionCode) {
        return
      }
      try {
        const res = await getInvitationMain(this.projectInfo.sectionCode)
        if (res.code === 200) {
          this.invitationMainUrl = res.data || ''
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        this.$message.error('获取投标文件正文失败')
      }
    },
    // 投标文件正文附件
    async loadInvitationAttList() {
      if (!this.projectInfo.sectionCode) {
        return
      }
      try {
        const res = await getInvitationAttList(this.projectInfo.sectionCode)
        if (res.code === 200) {
          this.invitationAttList = Array.isArray(res.data) ? res.data : []
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        this.$message.error('获取投标文件正文附件失败')
      }
    },

    /******** ----------------开标一览表相关----------------- ********/
    // 获取开标一览表
    async loadOpeningSummaryList() {
      if (!this.projectInfo.sectionCode) {
        return
      }
      try {
        const res = await getOpeningSummaryList(this.projectInfo.sectionCode)
        if (res.code === 200) {
          // 如果有加密数据且已获取对称密钥，自动解密
          if (res.data.encryptStatus == 1 && res.data.encryptData && this.symKey) {
            try {
              const encryptMethod = 0x00000401
              await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)

              const plainText = await this.xtxObject.SOF_SymDecryptData(this.symKey, res.data.encryptData)
              if (plainText) {
                this.openingSummaryList = JSON.parse(plainText)
                this.openingSummarySavedSnapshot = JSON.stringify(this.openingSummaryList || [])
              } else {
                this.$message.error('解密失败')
              }
            } catch (e) {
              console.error('解密失败:', e)
              this.$message.error('解密失败')
            }
          } else {
            this.openingSummaryList = Array.isArray(res.data.list) ? res.data.list : []
            this.openingSummarySavedSnapshot = JSON.stringify(this.openingSummaryList || [])
          }
          return
        }
        console.log(res);
        this.$message.error(res.msg)
      } catch (error) {
        this.$message.error('获取开标一览表失败')
      }
    },
    //新增开标一览表
    async addOpeningSummary(vl) {
      const res = await addOpeningSummary({
        sectionCode: this.projectInfo.sectionCode,
        encryptData: vl,
        secretKey: this.bidKeyInfo?.secretKey || ''
      })
      return res
    },

    /******** ----------------通用文件展示与下载----------------- ********/
    formatFileSize(size) {
      if (!size || Number(size) <= 0) {
        return '--'
      }
      const numericSize = Number(size)
      if (numericSize < 1024) {
        return `${numericSize} B`
      }
      if (numericSize < 1024 * 1024) {
        return `${(numericSize / 1024).toFixed(1)} KB`
      }
      return `${(numericSize / 1024 / 1024).toFixed(2)} MB`
    },
    handleDownloadPdf() {
      if (!this.invitationMainUrl) {
        this.$message.warning('暂无投标文件正文可下载')
        return
      }
      const link = document.createElement('a')
      link.href = this.invitationMainUrl
      link.target = '_blank'
      link.download = '投标文件正文.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    /******** ----------------开标一览表输入处理----------------- ********/
    // 判断是否需要中文大写
    isCapitalRequired(itemName) {
      if (!itemName) return false
      return itemName.includes('大写')
    },

    findCapitalTargetItem(sourceItemName) {
      if (!sourceItemName) return null
      const normalizedName = String(sourceItemName).replace(/\s+/g, '')

      if (normalizedName === '总价') {
        return this.openingSummaryList.find(item => {
          const itemName = String(item.itemName || '').replace(/\s+/g, '')
          return itemName === '总价(大写)' || itemName === '总价（大写）'
        })
      }

      if (normalizedName === '单价') {
        return this.openingSummaryList.find(item => {
          const itemName = String(item.itemName || '').replace(/\s+/g, '')
          return itemName === '单价(大写)' || itemName === '单价（大写）'
        })
      }

      return null
    },

    // 处理开标一览表内容输入，限制中文大写
    handleItemValueInput(row, index) {
      // 纯数字类型限制：只允许输入数字和小数点
      if (row.itemValueType == 1) {
        const value = row.itemValue || ''
        const filtered = value.replace(/[^\d.]/g, '')
        if (filtered !== value) {
          this.$set(this.openingSummaryList[index], 'itemValue', filtered)
        }

        const capitalTargetItem = this.findCapitalTargetItem(row.itemName)
        if (capitalTargetItem) {
          const capitalValue = filtered ? this.numberToChineseCapital(filtered) : ''
          this.$set(capitalTargetItem, 'itemValue', capitalValue)
        }

        return
      }
      if (!this.isCapitalRequired(row.itemName)) {
        // 如果不需要大写限制，直接返回
        return
      }
      const value = row.itemValue || ''
      // 中文大写数字正则表达式
      const chineseCapitalRegex = /^[零壹贰叁肆伍陆柒捌玖拾佰仟万亿元角分整]+$/
      if (!chineseCapitalRegex.test(value)) {
        // 只保留合法的中文大写字符
        const filteredValue = value.replace(/[^零壹贰叁肆伍陆柒捌玖拾佰仟万亿元角分整]/g, '')
        this.$set(this.openingSummaryList[index], 'itemValue', filteredValue)
        // 提示用户
        if (value !== filteredValue) {
          this.$message.warning('请输入中文大写数字')
        }
      }
    },
    // 数字转中文大写金额
    numberToChineseCapital(money) {
      // 处理空值和非数字
      if (!money || isNaN(parseFloat(money))) {
        return ''
      }

      const num = parseFloat(money)

      // 汉字的数字
      const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
      // 基本单位
      const cnIntRadice = ['', '拾', '佰', '仟']
      // 对应整数部分扩展单位
      const cnIntUnits = ['', '万', '亿', '兆']
      // 对应小数部分单位
      const cnDecUnits = ['角', '分']
      // 最大处理的数字
      const maxNum = 9999999999999999.99

      if (num >= maxNum) {
        return '金额过大'
      }

      if (num === 0) {
        return cnNums[0]
      }

      // 转换为字符串
      let moneyStr = num.toFixed(2)
      let integerNum // 金额整数部分
      let decimalNum // 金额小数部分

      // 分离金额整数部分和小数部分
      const parts = moneyStr.split('.')
      integerNum = parts[0]
      decimalNum = parts.length > 1 ? parts[1] : ''

      // 整数部分处理
      let chineseStr = ''
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0
        const intLen = integerNum.length

        for (let i = 0; i < intLen; i++) {
          const n = integerNum.substr(i, 1)
          const p = intLen - i - 1
          const q = p / 4
          const m = p % 4

          if (n === '0') {
            zeroCount++
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0]
            }
            zeroCount = 0
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
          }

          if (m === 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q]
          }
        }
      }

      // 小数部分处理
      if (decimalNum !== '' && decimalNum !== '00') {
        for (let i = 0; i < decimalNum.length; i++) {
          const n = decimalNum.substr(i, 1)
          if (n !== '0') {
            chineseStr += cnNums[parseInt(n)] + cnDecUnits[i]
          }
        }
      }
      if (chineseStr === '') {
        chineseStr = cnNums[0]
      }
      return chineseStr
    },

    /******** ----------------开标一览表保存/加密前置校验----------------- ********/
    checkCALogin() {
      if (!this.caLoggedIn) {
        this.$message.warning('请先登录 CA，再进行操作')
        return false
      }
      return true
    },

    // 校验当前选中的 CA 证书用户名是否与当前登录账户一致
    checkCAUserMatch() {

      return true
      // const cookieUserName = Cookies.get('userName')

      // if (!cookieUserName) {
      //   this.$message.error('未获取到当前登录用户信息，请重新登录')
      //   return false
      // }
      // const selectedCert = (this.certList || []).find(item => item.certid === this.caForm.certId)
      // const rawCertName = selectedCert?.name || this.currentCaUserName || ''
      // const cleanCertName = rawCertName.replace(/[（(][^）)]*[）)]/g, '').trim()
      // if (!cleanCertName) {
      //   this.$message.error('未获取到 CA 证书用户信息，请重新选择证书')
      //   return false
      // }
      // if (cleanCertName !== cookieUserName) {
      //   this.$message.error(`当前 CA 证书用户“${cleanCertName}”与登录账户“${cookieUserName}”不一致，无法操作`)
      //   return false
      // }
      // return true
    },

    // 校验加密密钥（secretKey）是否已就绪；缺失时阻止保存/加密上传
    checkSecretKey() {
      if (this.keyInfo) {
        return true

      }
      const secretKey = this.bidKeyInfo && this.bidKeyInfo.secretKey
      if (!secretKey) {
        this.$message.error('未获取到加密密钥（secretKey），无法保存或加密上传，请先完成 CA 登录并获取密钥')
        return false
      }
      return true
    },

    async handleEncryptClick() {
      if (this.isSaving) {
        this.$message.warning('正在保存中，请等待保存完成后再操作')
        return
      }
      const prerequisitesReady = await this.validateEncryptPrerequisites()
      if (!prerequisitesReady) return
      if (!this.checkCALogin()) return
      if (!this.checkCAUserMatch()) return
      if (!this.checkSecretKey()) return
      const saved = await this.saveCurrentCAKeyInfo()
      if (!saved) {
        this.$message.error('保存CA密钥信息失败，无法继续加密')
        return
      }
      await this.encryptOpeningSummaryList()
    },

    async refreshBidMainUploadedState(blindFlag) {
      try {
        const res = await getBidMain(this.projectInfo.sectionCode, blindFlag)
        const targetState = blindFlag === 1 ? this.mainDocStates.blind : this.mainDocStates.open
        if (res.code !== 200) {
          return false
        }
        const data = res.data || {}
        if (data.fileId) {
          targetState.bidMainUrl = data.fileId
          targetState.bidMainFileInfo = {
            ...data,
            fileName: data.fileName || (blindFlag === 1 ? '暗标正文' : (Number(this.isBlindReview) === 1 ? '明标正文' : '投标正文')),
            fileId: data.fileId
          }
          targetState.mainEncryptSuccess = true
          targetState.mainEncryptResult = `${blindFlag === 1 ? '暗标正文' : (Number(this.isBlindReview) === 1 ? '明标正文' : '投标正文')}已加密`
          return true
        }
        targetState.bidMainUrl = ''
        targetState.bidMainFileInfo = {}
        return false
      } catch (error) {
        console.error('刷新投标正文上传状态失败:', error)
        return false
      }
    },

    async validateEncryptPrerequisites() {
      if (!this.projectInfo.sectionCode) {
        this.$message.warning('缺少标段信息，无法校验文件上传状态')
        return false
      }

      const openUploaded = await this.refreshBidMainUploadedState(0)
      if (!openUploaded) {
        this.$message.warning(Number(this.isBlindReview) === 1 ? '请先上传已加密的明标正文' : '请先上传已加密的投标正文')
        this.activeMenu = '4-1'
        return false
      }

      if (Number(this.isBlindReview) === 1) {
        const blindUploaded = await this.refreshBidMainUploadedState(1)
        if (!blindUploaded) {
          this.$message.warning('请先上传已加密的暗标正文')
          this.activeMenu = '4-2'
          return false
        }
      }

      return true
    },

    getOpeningSummarySnapshot() {
      return JSON.stringify(Array.isArray(this.openingSummaryList) ? this.openingSummaryList : [])
    },

    hasOpeningSummaryChanges() {
      return this.getOpeningSummarySnapshot() !== (this.openingSummarySavedSnapshot || '[]')
    },

    async ensureSymKeyReady(options = {}) {
      const { showMessage = true } = options
      if (this.symKey) {
        return true
      }
      if (this.bidKeyInfo && this.bidKeyInfo.secretKey) {
        if (showMessage) {
          this.$message.warning('检测到已存在锁信息，请先点击解锁')
        }
        return false
      }
      try {
        const keyRes = await getBidKeyInfo(this.projectInfo.sectionCode)
        if (keyRes.code === 200 && keyRes.data && keyRes.data.secretKey) {
          this.bidKeyInfo = keyRes.data
          this.symKey = ''
          if (showMessage) {
            this.$message.warning('检测到已存在锁信息，请先点击解锁')
          }
          return false
        }
      } catch (error) {
        console.error('获取已有对称密钥失败:', error)
      }

      try {
        await this.getSymKeySilent()

        if (this.symKey) {
          // 新生成的key，用CA公钥加密后存入bidKeyInfo.secretKey，保存时使用
          try {
            await this.exportExchangeCert(this.caForm.certId)
            const usable = await this.verifyKeyPairUsable()
            if (!usable) {
              this.symKey = ''
              this.bidKeyInfo = null
              if (showMessage) {
                this.$message.error('当前 CA 证书加密/私钥不匹配（可能是单位锁/个人锁不一致），请切换正确的 CA 后重试')
              }
              return false
            }
            if (this.asymForm.cert) {
              const cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.symKey)
              if (cipher) {
                this.bidKeyInfo = { secretKey: cipher }
              }
            }
          } catch (e) {
            console.error('新密钥加密失败，secretKey将为空:', e)
          }
          if (!this.bidKeyInfo || !this.bidKeyInfo.secretKey) {
            if (showMessage) {
              this.$message.warning('缺少加密密钥，无法继续保存或加密上传')
            }
            return false
          }
          return true
        }
      } catch (error) {
        console.error('生成对称密钥失败:', error)
      }

      if (showMessage) {
        this.$message.warning('请先获取对称密钥')
      }
      return false
    },

    /******** ----------------开标一览表保存相关----------------- ********/
    // 校验开标一览表所有项均已填写（不允许空字符串/空白）
    validateOpeningSummaryList() {
      if (!Array.isArray(this.openingSummaryList) || this.openingSummaryList.length === 0) {
        return true
      }
      for (let i = 0; i < this.openingSummaryList.length; i++) {
        const row = this.openingSummaryList[i] || {}
        const raw = row.itemValue
        const value = raw == null ? '' : String(raw).trim()
        if (!value) {
          const label = row.itemName || ('第' + (i + 1) + '项')
          this.$message.warning(`请填写开标一览表「${label}」的内容`)
          return false
        }
      }
      return true
    },

    async saveOpeningSummaryIfNeeded(options = {}) {
      const { force = false, showSuccess = true } = options
      if (!Array.isArray(this.openingSummaryList) || this.openingSummaryList.length === 0) {
        return false
      }
      if (!this.validateOpeningSummaryList()) {
        throw new Error('开标一览表存在未填写项')
      }
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) {
        return false
      }
      if (!force && !this.hasOpeningSummaryChanges()) {
        return false
      }
      const plainText = JSON.stringify(this.openingSummaryList)
      const encryptMethod = 0x00000401
      const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
      if (setResult !== 0) {
        this.$message.error('设置加密算法失败!')
        throw new Error('设置加密算法失败')
      }
      const cipherText = await this.xtxObject.SOF_SymEncryptData(this.symKey, plainText)

      if (!cipherText) {
        this.$message.error('开标一览表加密失败!')
        throw new Error('开标一览表加密失败')
      }
      const res = await this.addOpeningSummary(cipherText)
      if (res && res.code !== 200) {
        this.$message.error(res.msg || '开标一览表保存失败')
        this.saveCurrentCAKeyInfo()
        throw new Error(res.msg || '开标一览表保存失败')
      }
      this.openingSummarySavedSnapshot = this.getOpeningSummarySnapshot()
      if (showSuccess) {
        this.$message.success('开标一览表保存成功')
      }
      return true
    },

    async handleOpeningSummarySave() {
      if (this.isSaving) return
      if (!this.checkCALogin()) return
      if (!this.checkCAUserMatch()) return
      if (!this.checkSecretKey()) return
      this.isSaving = true
      const loading = this.$loading({ text: '正在保存...', spinner: 'el-icon-loading' })
      try {
        await this.saveCurrentCAKeyInfo()
        const keyReady = await this.ensureSymKeyReady({ showMessage: true })
        if (!keyReady) return
        await this.saveOpeningSummaryIfNeeded({ force: true, showSuccess: true })
      } finally {
        loading.close()
        this.isSaving = false
      }
    },

    /******** ----------------投标附件与投标正文保存入口（旧加解密逻辑已移除）----------------- ********/
    async handleBidAttSave() {
      if (this.isSaving) return
      this.isSaving = true
      const loading = this.$loading({ text: '正在保存...', spinner: 'el-icon-loading' })
      try {
        await this.saveOpeningSummaryIfNeeded({ force: false, showSuccess: true })
      } finally {
        loading.close()
        this.isSaving = false
      }
    },

    async selectBidAttFilePath() {
      try {
        await this.xtxObject.initWebSocket()
        const filePath = await this.xtxObject.SelectFile()
        if (!filePath) {
          return
        }
        const fileName = filePath.split(/[\\/]/).pop() || filePath
        this.attEncryptList.push({
          id: `${Date.now()}_${Math.random()}`,
          filePath,
          fileName,
          outFilePath: this.buildNamedLocalPath(filePath, '附件'),
          encrypting: false,
          encryptSuccess: false,
          encryptResult: '',
          encryptedFileName: '',
          encryptedFile: null,
          uploadSuccess: false
        })
        this.$message.success('已添加附件文件')
      } catch (error) {
        console.error('选择附件文件失败:', error)
        this.$message.error('选择附件文件失败：' + (error.message || '未知错误'))
      }
    },

    removeBidAttEncryptItem(index) {
      this.attEncryptList.splice(index, 1)
    },

    async encryptBidAttFile(item) {
      if (!item || item.encrypting) return
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) return
      item.encrypting = true
      item.encryptResult = ''
      try {
        await this.xtxObject.initWebSocket()
        const encryptMethod = 0x00000401
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
        if (setResult !== 0) {
          item.encryptResult = '设置加密算法失败'
          this.$message.error(item.encryptResult)
          return
        }
        const ret = await this.xtxObject.SOF_SymEncryptFile(this.symKey, item.filePath, item.outFilePath)
        const success = ret === true || ret === 'true' || ret === 'TRUE' || ret === 1 || ret === '1'
        item.encryptSuccess = success
        item.encryptResult = success ? '上传文件' : '附件加密失败'
        this.$message[success ? 'success' : 'error'](item.encryptResult)
      } catch (error) {
        console.error('附件加密失败:', error)
        item.encryptResult = '附件加密异常'
        this.$message.error('附件加密失败：' + (error.message || '未知错误'))
      } finally {
        item.encrypting = false
      }
    },

    async handleEncryptedBidAttBrowserFileChange(file, item) {
      const rawFile = file && file.raw
      if (!rawFile || !item) {
        this.$message.warning('请选择加密附件文件')
        return
      }
      if (!this.isEncFile(rawFile.name)) {
        this.$message.warning('请选择 .enc 格式的加密文件')
        return
      }
      item.encryptedFileName = rawFile.name || ''
      item.encryptedFile = rawFile
      const loading = this.$loading({ text: `正在上传附件 ${item.fileName}...`, spinner: 'el-icon-loading' })
      try {
        try { rawFile.fileType = 'bid-att' } catch (e) { /* read-only */ }
        const uploadResult = await doFileUpload(rawFile, {
          fileBindId: this.fileBindId,
          fileType: 'bid-att'
        })
        if (!uploadResult || !uploadResult.success) {
          this.$message.error('附件上传失败：' + (uploadResult && uploadResult.message || '未知错误'))
          return
        }
        const uploadedFileId = uploadResult.fileId || uploadResult.uploadFileId || ''
        if (!uploadedFileId) {
          this.$message.error('附件上传返回缺少 fileId')
          return
        }
        const res = await uploadBidAtt({
          sectionCode: this.projectInfo.sectionCode,
          fileId: uploadedFileId,
          fileBindId: this.fileBindId
        })
        if (res.code === 200) {
          item.uploadSuccess = true
          await this.loadBidAttList()
          this.$message.success('附件上传成功')
        } else {
          this.$message.error(res.msg || '附件上传关联失败')
        }
      } catch (error) {
        console.error('附件上传失败:', error)
        this.$message.error('附件上传失败：' + (error.message || '未知错误'))
      } finally {
        loading.close()
      }
    },

    async handleBidMainSave() {
      if (this.isSaving) return
      this.isSaving = true
      const loading = this.$loading({ text: '正在保存...', spinner: 'el-icon-loading' })
      try {
        await this.saveOpeningSummaryIfNeeded({ force: false, showSuccess: true })
        await this.loadInvitationCatalogue()
      } finally {
        try { loading.close() } catch (e) { /* already closed */ }
        this.isSaving = false
      }
    },

    handleMainPdfChange(file) {
      const rawFile = file && file.raw
      if (!rawFile) {
        this.$message.warning('文件不存在')
        return
      }
      if ((rawFile.type && rawFile.type !== 'application/pdf') || !this.isPdfFileName(rawFile.name)) {
        this.$message.warning('请选择 PDF 文件')
        return
      }
      if (this.currentMainState.previewMainUrl) {
        URL.revokeObjectURL(this.currentMainState.previewMainUrl)
      }
      this.currentMainState.pendingMainFile = file
      this.currentMainState.previewMainUrl = URL.createObjectURL(rawFile)
      this.currentMainState.mainFilePath = ''
      this.currentMainState.mainOutFilePath = ''
      this.currentMainState.encryptedMainFilePath = ''
      this.currentMainState.mainEncryptResult = ''
      this.currentMainState.mainEncryptSuccess = false
      this.currentMainState.pdfBase64 = ''
      this.mainPdfReading = true
      const reader = new FileReader()
      reader.onload = () => {
        const result = reader.result || ''
        this.currentMainState.pdfBase64 = String(result).includes(',') ? String(result).split(',').pop() : String(result)
        this.mainPdfReading = false
      }
      reader.onerror = () => {
        this.$message.error('读取 PDF 失败')
        this.mainPdfReading = false
      }
      reader.readAsDataURL(rawFile)
      this.$message.success(`已选择${this.currentMainLabel}原文 PDF，正在读取内容...`)
    },

    setMainOriginalPreviewFromBase64(base64, fileName = '') {
      const state = this.mainDocStates.open
      if (state.previewMainUrl) {
        URL.revokeObjectURL(state.previewMainUrl)
      }
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' })
      state.previewMainUrl = URL.createObjectURL(blob)
      state.pendingMainFile = {
        name: fileName || 'bid-main.pdf',
        raw: blob
      }
      state.pdfBase64 = base64
    },

    async selectOpenMainPdfPath() {
      try {
        await this.xtxObject.initWebSocket()
        const filePath = await this.xtxObject.SelectFile()
        if (!filePath) return
        if (!this.isPdfFileName(filePath)) {
          this.$message.warning('明标正文只能选择 PDF 文件')
          return
        }
        this.mainDocStates.open.sourcePdfPath = filePath
        this.mainDocStates.open.mainFilePath = filePath
        this.mainDocStates.open.mainOutFilePath = this.buildNamedLocalPath(filePath, '明标文件')
        this.mainDocStates.open.signedFilePath = ''
        this.mainDocStates.open.encryptedMainFilePath = ''
        this.mainDocStates.open.mainEncryptResult = ''
        this.mainDocStates.open.mainEncryptSuccess = false
        this.$message.success('已选择明标正文文件')
      } catch (e) {
        this.$message.error('选择文件失败')
      }
    },

    async selectBlindMainFilePath() {
      try {
        await this.xtxObject.initWebSocket()
        const filePath = await this.xtxObject.SelectFile()
        if (!filePath) {
          return
        }
        if (!this.isPdfFileName(filePath)) {
          this.$message.warning('暗标正文只能选择 PDF 文件')
          return
        }
        this.mainDocStates.blind.mainFilePath = filePath
        this.mainDocStates.blind.mainOutFilePath = this.buildNamedLocalPath(filePath, '暗标文件')
        this.mainDocStates.blind.encryptedMainFilePath = ''
        this.mainDocStates.blind.mainEncryptResult = ''
        this.mainDocStates.blind.mainEncryptSuccess = false
        this.$message.success('已选择暗标正文文件')
      } catch (error) {
        console.error('选择暗标正文文件失败:', error)
        this.$message.error('选择暗标正文文件失败：' + (error.message || '未知错误'))
      }
    },

    buildSignTimestamp() {
      const pad = n => String(n).padStart(2, '0')
      const now = new Date()
      return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}${now.getMilliseconds()}`
    },

    joinLocalPath(dir, fileName) {
      return `${String(dir || DEFAULT_SIGN_SAVE_DIR).replace(/[\\/]+$/, '')}\\${fileName}`
    },

    getPathDir(filePath) {
      const path = filePath || ''
      const idx = Math.max(path.lastIndexOf('\\'), path.lastIndexOf('/'))
      return idx >= 0 ? path.slice(0, idx) : ''
    },

    buildNamedLocalPath(sourcePath, prefix, extension = '.enc') {
      const dir = ENCRYPT_OUT_DIR
      const sep = Math.max((sourcePath || '').lastIndexOf('\\'), (sourcePath || '').lastIndexOf('/'))
      const baseName = sep >= 0 ? sourcePath.slice(sep + 1) : (sourcePath || '')
      const fileName = baseName || `${prefix}${this.buildSignTimestamp()}`
      return this.joinLocalPath(dir, `${fileName}${extension}`)
    },

    buildBidMainSignPath() {
      return this.joinLocalPath(DEFAULT_SIGN_SAVE_DIR, `明标文件${this.buildSignTimestamp()}.pdf`)
    },

    async handleGoSign() {
      if (this.currentMainBlindFlag === 1) {
        this.$message.warning('暗标正文不需要签章')
        return
      }
      if (!this.currentMainState.sourcePdfPath) {
        this.$message.warning('请先选择正文 PDF')
        return
      }
      const savePath = this.currentMainState.signedFilePath || this.buildBidMainSignPath()
      this.currentMainState.signedFilePath = savePath
      this.currentMainState.mainFilePath = savePath
      this.currentMainState.mainOutFilePath = this.buildNamedLocalPath(savePath, '明标文件')
      window.__caLocalSignPdfData = {
        fileName: this.currentMainState.sourcePdfPath.split(/[\\/]/).pop() || `${this.currentMainLabel}.pdf`,
        fileBase64: '',
        sourceFilePath: this.currentMainState.sourcePdfPath,
        savePath,
        returnPath: this.$route.fullPath || '/makeBidDocument',
        bidMainSign: true,
        blindFlag: this.currentMainBlindFlag
      }
      try {
        // draft 只存元数据，不存 fileBase64
        sessionStorage.setItem(BID_MAIN_SIGN_DRAFT_KEY, JSON.stringify({
          fileName: this.currentMainState.pendingMainFile?.name || `${this.currentMainLabel}.pdf`,
          savePath
        }))
        sessionStorage.setItem(SIGN_STORAGE_KEY, JSON.stringify({
          fileName: this.currentMainState.pendingMainFile?.name || `${this.currentMainLabel}.pdf`,
          savePath,
          saveType: 'path',
          returnPath: this.$route.fullPath || '/makeBidDocument',
          useMemory: true,
          bidMainSign: true,
          blindFlag: this.currentMainBlindFlag
        }))
        sessionStorage.setItem(BID_MAIN_SIGN_KEEP_STATE_KEY, JSON.stringify({
          symKey: this.symKey || '',
          bidKeyInfo: this.bidKeyInfo || null,
          caLoggedIn: !!this.caLoggedIn,
          currentCaUserName: this.currentCaUserName || '',
          certId: this.caForm?.certId || '',
          asymCert: this.asymForm?.cert || ''
        }))
      } catch (e) {
        console.warn('sessionStorage 写入失败（文件可能过大），继续跳转签章页', e)
      }
      sessionStorage.removeItem(SIGN_RESULT_KEY)
      this.$router.push({
        path: '/sign/pdf',
        query: {
          sectionCode: this.projectInfo.sectionCode || '',
          source: 'cache',
          saveType: 'path',
          savePath,
          returnPath: this.$route.fullPath || '/makeBidDocument'
        }
      })
    },

    checkBidMainSignResult() {
      const resultText = sessionStorage.getItem(SIGN_RESULT_KEY)
      if (!resultText) {
        return
      }
      try {
        const result = JSON.parse(resultText)
        const state = this.mainDocStates.open
        const savePath = result.savePath || result.actualSavePath || state.signedFilePath
        state.signedFilePath = savePath
        state.mainFilePath = savePath
        state.mainOutFilePath = savePath ? this.buildNamedLocalPath(savePath, '明标文件') : ''
        state.mainEncryptResult = ''
        state.mainEncryptSuccess = false
        const signedBase64 = window.__caLocalSignPdfData && window.__caLocalSignPdfData.signedBase64
        if (signedBase64) {
          this.setMainSignedPreviewFromBase64(signedBase64, savePath)
        }
        this.activeMenu = '4-1'
        this.$message.success('签章完成，请确认签章后预览并继续加密')
      } catch (error) {
        console.error('读取正文签章结果失败:', error)
      } finally {
        sessionStorage.removeItem(SIGN_RESULT_KEY)
        sessionStorage.removeItem(BID_MAIN_SIGN_DRAFT_KEY)
      }
    },

    setMainSignedPreviewFromBase64(base64, filePath = '') {
      const state = this.mainDocStates.open
      if (state.signedPreviewUrl) {
        URL.revokeObjectURL(state.signedPreviewUrl)
      }
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' })
      state.signedPreviewUrl = URL.createObjectURL(blob)
      state.signedPdfFileName = (filePath || '').split(/[\\/]/).pop() || 'signed.pdf'
    },

    handleSignedMainPdfChange(file) {
      const rawFile = file && file.raw
      if (!rawFile) {
        return
      }
      if (rawFile.type && rawFile.type !== 'application/pdf') {
        this.$message.warning('请选择 PDF 文件')
        return
      }
      if (this.currentMainState.signedPreviewUrl) {
        URL.revokeObjectURL(this.currentMainState.signedPreviewUrl)
      }
      this.currentMainState.signedPreviewUrl = URL.createObjectURL(rawFile)
      this.currentMainState.signedPdfFileName = rawFile.name || ''
      this.$message.success('已加载签章后 PDF 预览')
    },

    getFolderPath(filePath) {
      const path = filePath || ''
      const idx = Math.max(path.lastIndexOf('\\'), path.lastIndexOf('/'))
      return idx >= 0 ? path.slice(0, idx) : path
    },

    async copyFolderPath(filePath) {
      const folder = this.getFolderPath(filePath)
      if (!folder) {
        this.$message.warning('暂无可复制的文件夹路径')
        return
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(folder)
        } else {
          const ta = document.createElement('textarea')
          ta.value = folder
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }
        this.$message.success('已复制文件夹路径')
      } catch (error) {
        console.error('复制文件夹路径失败:', error)
        this.$message.error('复制失败，请手动复制')
      }
    },

    async handleBidMainFileEncrypt() {
      if (this.mainFileEncrypting) return
      if (!this.currentMainState.mainFilePath) {
        this.$message.warning('请先选择正文文件')
        return
      }
      if (!this.currentMainState.mainOutFilePath) {
        this.$message.warning('请填写密文输出路径')
        return
      }
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) return
      this.mainFileEncrypting = true
      this.currentMainState.mainEncryptResult = ''
      this.currentMainState.mainEncryptSuccess = false
      try {
        await this.xtxObject.initWebSocket()
        const encryptMethod = 0x00000401
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
        if (setResult !== 0) {
          this.$message.error('设置加密算法失败!')
          this.currentMainState.mainEncryptResult = '设置加密算法失败'
          return
        }
        const ret = await this.xtxObject.SOF_SymEncryptFile(
          this.symKey,
          this.currentMainState.mainFilePath,
          this.currentMainState.mainOutFilePath
        )
        const success = ret === true || ret === 'true' || ret === 'TRUE' || ret === 1 || ret === '1'
        this.currentMainState.mainEncryptSuccess = success
        this.currentMainState.mainEncryptResult = success ? '上传文件' : '正文文件加密失败'
        this.$message[success ? 'success' : 'error'](this.currentMainState.mainEncryptResult)
      } catch (error) {
        console.error('正文文件加密失败:', error)
        this.currentMainState.mainEncryptResult = '正文文件加密异常'
        this.$message.error('正文文件加密失败：' + (error.message || '未知错误'))
      } finally {
        this.mainFileEncrypting = false
      }
    },

    async handleEncryptedBidMainBrowserFileChange(file) {
      const rawFile = file && file.raw
      if (!rawFile) {
        this.$message.warning('请选择加密文件')
        return
      }
      if (!this.isEncFile(rawFile.name)) {
        this.$message.warning('请选择 .enc 格式的加密文件')
        return
      }
      this.currentMainState.encryptedMainFilePath = rawFile.name || ''
      const targetBlindFlag = this.currentMainBlindFlag
      const targetLabel = this.currentMainLabel
      const loading = this.$loading({ text: `正在上传${targetLabel}...`, spinner: 'el-icon-loading' })
      try {
        try { rawFile.fileType = 'bid-main' } catch (e) { /* read-only */ }
        const uploadResult = await doFileUpload(rawFile, {
          fileBindId: this.fileBindId,
          fileType: 'bid-main'
        })
        if (!uploadResult || !uploadResult.success) {
          this.$message.error(`${targetLabel}上传失败：` + (uploadResult && uploadResult.message || '未知错误'))
          return
        }
        const uploadedFileId = uploadResult.fileId || uploadResult.uploadFileId || ''
        if (!uploadedFileId) {
          this.$message.error(`${targetLabel}上传返回缺少 fileId`)
          return
        }
        const res = await uploadBidSign({
          sectionCode: this.projectInfo.sectionCode,
          fileId: uploadedFileId,
          fileBindId: this.fileBindId,
          isBlindReview: targetBlindFlag
        })
        if (res.code === 200) {
          await this.getBidMain()
          this.$message.success(`${targetLabel}上传成功`)
        } else {
          this.$message.error(res.msg || `${targetLabel}上传关联失败`)
        }
      } catch (error) {
        console.error(`${targetLabel}上传失败:`, error)
        this.$message.error(`${targetLabel}上传失败：` + (error.message || '未知错误'))
      } finally {
        loading.close()
      }
    },

    isEncFile(fileName) {
      return /\.enc$/i.test(fileName || '')
    },

    isPdfFileName(fileName) {
      return /\.pdf$/i.test(fileName || '')
    },

    /******** ----------------正文目录与PDF预览相关----------------- ********/
    handleMenuSelect(key) {
      this.activeMenu = key
      if (key === '3-1') {
        this.loadBidAttList()
      }
      if (key === '4-1' || key === '4-2') {
        this.getBidMain()
        if (key === '4-1') {
          this.loadInvitationCatalogue()
        }
      }
    },

    handleCatalogueClick(data) {
      if (data && data.pageNum) {
        this.jumpBidPdf(data.pageNum)
      } else {
        this.$message.info('该目录未关联页码')
      }
    },

    async bindCataloguePage(item) {
      if (!item) return
      if (!this.currentBidPage) {
        this.$message.warning('无法获取当前页码')
        return
      }
      const res = await getBidCatalogue({
        id: item.strId,
        pageNum: this.currentBidPage,
        sectionCode: item.bidSectionCode || this.projectInfo.sectionCode,
        isBlindReview: this.currentMainBlindFlag
      })
      if (res.code === 200) {
        this.$message.success(`已关联到第${this.currentBidPage}页`)
        this.loadInvitationCatalogue()
      } else {
        this.$message.error(res.msg || '关联页码失败')
      }
    },

    async loadInvitationCatalogue() {
      try {
        const res = await getInvitationCatalogue(this.projectInfo.sectionCode, this.currentMainBlindFlag)
        if (res.code === 200) {
          this.catalogueList = Array.isArray(res.data) ? res.data : []
        } else {
          this.$message.error(res.msg || '获取目录失败')
        }
      } catch (error) {
        console.error('获取目录失败:', error)
      }
    },

    onBidPdfLoaded() {
      this.currentMainState.currentMainPdfLoadedUrl = this.mainPdfDisplayUrl || ''
    },

    handleBidPdfError(error) {
      console.warn('投标正文 PDF 加载事件异常:', error)
      if (!this.mainPdfDisplayUrl) {
        return
      }
      if (this.currentMainState.currentMainPdfLoadedUrl && this.currentMainState.currentMainPdfLoadedUrl === this.mainPdfDisplayUrl) {
        return
      }
    },

    onBidPdfPageChanged(event) {
      try {
        this.currentBidPage = typeof event === 'number'
          ? event
          : (event && (event.pageNumber || event.page || event.currentPage)) || this.currentBidPage
      } catch (error) {
        console.error('PDF页码变化处理错误:', error)
      }
    },

    jumpBidPdf(page) {
      const viewer = this.$refs.bidPdfViewer
      if (viewer && typeof viewer.goToPage === 'function') {
        viewer.goToPage(page)
      } else {
        this.$message.warning('PDF预览尚未就绪')
      }
    },

    downloadBidMain() {
      if (!this.mainPdfDisplayUrl) {
        this.$message.warning(`暂无可下载的${this.currentMainLabel}`)
        return
      }
      const link = document.createElement('a')
      link.href = this.mainPdfDisplayUrl
      link.download = `${this.currentMainLabel}.pdf`
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    /******** ----------------签章跳转返回页面状态恢复----------------- ********/
    restorePageStateAfterSign() {
      try {
        const raw = sessionStorage.getItem(BID_MAIN_SIGN_KEEP_STATE_KEY)
        if (!raw) return false
        const state = JSON.parse(raw) || {}
        if (state.symKey) this.symKey = state.symKey
        if (state.bidKeyInfo) this.bidKeyInfo = state.bidKeyInfo
        if (state.caLoggedIn) this.caLoggedIn = true
        if (state.currentCaUserName) this.currentCaUserName = state.currentCaUserName
        if (state.certId && this.caForm) this.caForm.certId = state.certId
        if (state.asymCert && this.asymForm) this.asymForm.cert = state.asymCert
        sessionStorage.removeItem(BID_MAIN_SIGN_KEEP_STATE_KEY)
        return true
      } catch (e) {
        console.error('恢复签章前页面状态失败:', e)
        return false
      }
    },
    /******** ----------------CA控件登录与证书选择----------------- ********/
    // 初始化证书列表（静默获取）
    async initCertList(skipStatusCheck = false) {
      this.isLoadingCert = true
      try {
        await this.xtxObject.initWebSocket()
        const ukeyList = await this.xtxObject.SOF_GetUserList()
        this.certList = ukeyList
        this.syncLockedCertSelection()
        const cachedCAUser = this.getCachedCAUser()
        if (!this.caForm.certId && cachedCAUser?.certId) {
          const cachedUser = this.certList.find(item => item.certid === cachedCAUser.certId)
          if (cachedUser) {
            this.caForm.certId = cachedUser.certid
            this.currentCaUserName = cachedUser.name || cachedCAUser.name || ''
          }
        }
        if (this.certList.length > 0 && !this.caForm.certId) {
          this.caForm.certId = this.certList[0].certid
          this.currentCaUserName = this.certList[0].name
        }
        if (!skipStatusCheck) {
          await this.checkCALoginStatus(false)
        }
      } catch (e) {
        console.error('获取证书列表失败:', e)
      } finally {
        this.isLoadingCert = false
      }
    },
    // 获取当前操作用的 certId
    // 解密时优先用 bidKeyInfo.cakeyId（服务器记录的、当初加密用的 certId），确保加解密用同一证书
    getCurrentOperateCertId() {
      return this.bidKeyInfo?.cakeyId || this.caForm.certId || this.defaultCaCertId
    },
    async resolveCurrentCAUser() {
      if (!Array.isArray(this.certList) || this.certList.length === 0) {
        return null
      }
      try {
        const lastLoginCertId = await this.xtxObject.SOF_GetLastLoginCertID()
        if (lastLoginCertId) {
          return this.certList.find(item => item.certid === lastLoginCertId) || null
        }
      } catch (error) {
        console.warn('获取最后一次登录证书失败:', error)
      }
      return this.certList.find(item => item.certid === this.caForm.certId) || this.certList[0] || null
    },
    handleCAUserChange(certId) {
      const currentUser = this.certList.find(item => item.certid === certId)
      this.currentCaUserName = currentUser?.name || ''
      // 如果已登录，根据选中用户更新当前显示
      if (this.caLoggedIn && currentUser) {
        this.currentCaUserName = currentUser.name || '已登录用户'
      }
      if (currentUser) {
        this.cacheCurrentCAUser()
      }
    },
    getSelectedCADisplayName() {
      return this.currentCaUserName || '未选择'
    },
    getSelectedCADisplayId() {
      const certId = this.caForm.certId || ''
      if (!certId || certId === this.defaultCaCertId) {
        return '未选择'
      }
      return certId
    },
    async saveCurrentCAKeyInfo() {
      const caKeyId = this.caForm.certId
      const caKeyName = this.currentCaUserName

      if (!this.projectInfo.sectionCode || !caKeyId || !caKeyName) {
        return false
      }
      const res = await saveKeyInfo({
        sectionCode: this.projectInfo.sectionCode,
        caKeyId,
        caKeyName
      })
      if (res.code === 200) {
        // 更新本地 bidKeyInfo 中的 caKeyId 和 caKeyName
        if (this.bidKeyInfo) {
          this.bidKeyInfo.caKeyId = caKeyId
          this.bidKeyInfo.caKeyName = caKeyName
        }
      }
      return res.code === 200
    },

    async checkCALoginStatus(showMessage = true) {
      this.caStatusLoading = true
      try {
        await this.xtxObject.initWebSocket()
        const result = await this.xtxObject.SOF_IsLogin(this.defaultCaCertId)
        const loggedIn = result === true || result === 'true'
        this.caLoggedIn = loggedIn
        if (loggedIn) {
          // 刷新证书列表，从列表中识别当前用户
          const ukeyList = await this.xtxObject.SOF_GetUserList()
          this.certList = Array.isArray(ukeyList) ? ukeyList : []
          if (this.certList.length > 0) {
            const currentUser = await this.resolveCurrentCAUser()
            if (currentUser) {
              this.caForm.certId = currentUser.certid
              this.currentCaUserName = currentUser.name || '已登录用户'
            }
          }
          // 已登录则自动获取密钥并解密开标一览表
          await this.getBidKeyInfoAndDecrypt()
        } else {
          this.currentCaUserName = ''
        }
        if (showMessage) {
          this.$message[loggedIn ? 'success' : 'warning'](loggedIn ? 'CA 当前已登录' : 'CA 当前未登录')
        }
      } catch (error) {
        console.error('检查 CA 登录状态失败:', error)
        if (showMessage) {
          this.$message.error('检查 CA 登录状态失败')
        }
      } finally {
        this.caStatusLoading = false
      }
    },

    // CA登录
    async handleCALogin() {
      this.caLoading = true
      try {
        await this.xtxObject.initWebSocket()
        if (!this.caForm.certId) {
          await this.initCertList(true)
        }
        if (!this.caForm.certId) {
          this.$message.warning('未检测到 UKEY 证书，请插入 UKEY 后重试')
          return
        }
        const certId = this.caForm.certId
        const result = await this.xtxObject.SOF_Login(certId, '111111')
        if (result) {
          this.caLoggedIn = true
          await this.initCertList(true)
          if (this.certList.length > 0) {
            const currentUser = await this.resolveCurrentCAUser()
            if (currentUser) {
              this.caForm.certId = currentUser.certid
              this.currentCaUserName = currentUser.name || ''
              this.cacheCurrentCAUser()
            }
          }
          if (!this.caForm.certId) {
            this.$message.error('未识别到当前登录证书，请确认扫码登录是否完成')
            return
          }
          this.$message.success('CA登录成功')
          // 登录成功后导出加密证书（必须用实际登录用户的 certId，不能用 defaultCaCertId）
          await this.exportExchangeCert(this.caForm.certId)
          // 登录成功后自动获取密钥并解密
          await this.getBidKeyInfoAndDecrypt()

        } else {
          this.$message.error('CA登录失败')
        }
      } catch (error) {
        console.error('CA登录错误:', error)
        this.$message.error('CA登录失败：' + (error.message || '未知错误'))
      } finally {
        this.caLoading = false
      }
    },
    //ca退出
    async handleCALogout(showMessage = true, options = {}) {
      const { preserveLockInfo = false } = options
      this.caLogoutLoading = true
      try {
        await this.xtxObject.initWebSocket()
        const result = await this.xtxObject.SOF_Logout(this.defaultCaCertId)
        const success = result === true || result === 'true' || result === 0 || result === '0' || result === 1 || result === '1'
        this.caLoggedIn = false
        this.currentCaUserName = ''
        this.asymForm.cert = ''
        this.symKey = ''
        if (!preserveLockInfo) {
          this.bidKeyInfo = null
          this.unlockStepText = ''
          this.unlockStepStatus = 'idle'
        }
        if (showMessage) {
          this.$message[success ? 'success' : 'warning'](success ? 'CA 已退出登录' : 'CA 退出结果待确认')
        }
        this.caForm.certId = '';
        return success
      } catch (error) {
        console.error('CA退出错误:', error)
        if (showMessage) {
          this.$message.error('CA退出失败：' + (error.message || '未知错误'))
        }
        return false
      } finally {
        this.caLogoutLoading = false
      }
    },

    async handleCASwitch() {
      this.caSwitchLoading = true
      try {
        await this.handleCALogout(false, { preserveLockInfo: true })
        this.currentCaUserName = ''
        await this.handleCALogin()
      } catch (error) {
        console.error('切换 CA 失败:', error)
        this.$message.error('切换 CA 失败：' + (error.message || '未知错误'))
      } finally {
        this.caSwitchLoading = false
      }
    },

    /******** ----------------CA证书导出与密钥自检----------------- ********/
    // 导出加密证书（Exchange证书用于公钥加密）
    async exportExchangeCert(certId) {
      try {
        const result = await this.xtxObject.SOF_ExportExChangeUserCert(certId)
        if (result) {
          this.asymForm.cert = result
        } else {
          this.$message.error('导出加密证书失败')
        }
      } catch (e) {
        console.error('导出加密证书错误:', e)
        this.$message.error('导出加密证书失败：' + (e.message || '未知错误'))
      }
    },
    // 校验当前 CA 的加密证书与私钥是否真正匹配
    // 解决：单位锁/个人锁 certId 一致但底层物理私钥不同，导致加密成功、解密失败的问题
    async verifyKeyPairUsable() {
      try {
        if (!this.asymForm.cert || !this.caForm.certId) {
          return false
        }
        const probe = 'KEYPAIR_PROBE_' + Date.now()
        const cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, probe)
        if (!cipher) {
          return false
        }
        const decrypted = await this.xtxObject.SOF_PriKeyDecrypt(this.caForm.certId, cipher)
        return decrypted === probe
      } catch (e) {
        console.error('密钥对自检失败:', e)
        return false
      }
    },

    /******** ----------------开标保障密钥导出----------------- ********/
    async finishBidMakeAndExportKey() {
      if (!this.symKey) {
        this.$message.warning('缺少对称密钥，无法导出开标保障密钥')
        return
      }
      if (!this.caLoggedIn) {
        this.$message.warning('请先完成CA登录')
        return
      }
      if (!this.caForm.certId) {
        this.$message.error('未检测到登录用户，请重新 CA 登录后再操作')
        return
      }
      await this.exportExchangeCert(this.caForm.certId)
      if (!this.asymForm.cert) {
        this.$message.error('导出加密证书失败，无法生成开标保障密钥')
        return
      }
      const usable = await this.verifyKeyPairUsable()
      if (!usable) {
        this.$message.error('当前 CA 证书加密/私钥不匹配（可能是单位锁/个人锁不一致），请切换正确的 CA 后重试')
        return
      }
      let cipher = ''
      try {
        cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.symKey)
      } catch (error) {
        console.error('开标保障密钥公钥加密失败:', error)
        this.$message.error('开标保障密钥加密失败：' + (error.message || '未知错误'))
        return
      }
      if (!cipher) {
        this.$message.error('开标保障密钥加密失败')
        return
      }
      const res = await finishBidMake({
        secretKey: cipher,
        sectionCode: this.projectInfo.sectionCode,
        caKeyId: this.caForm.certId,
        caKeyName: this.currentCaUserName
      })
      if (res.code === 200) {
        // 下载加密前的原始对称密钥（本地 symKey），而非接口返回的加密数据
        if (this.symKey) {
          const blob = new Blob([this.symKey], { type: 'text/plain;charset=utf-8' })
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '开标保障密钥.txt'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        }


        setTimeout(() => {
          this.$router.go(-1)
        }, 1000);
      } else {
        this.$message.error(res.msg || '导出开标保障密钥失败')
      }
    },

    /******** ----------------开标一览表对称密钥生成与加密提交----------------- ********/
    // 静默获取对称密钥
    async getSymKeySilent() {
      try {
        const encryptMethod = 0x00000401
        await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
        const key = await this.xtxObject.SOF_GenRandom(16)
        if (key) {
          this.symKey = key
        }
      } catch (e) {
        console.error('获取对称密钥失败:', e)
      }
    },
    // 加密开标一览表数据并打印
    async encryptOpeningSummaryList() {
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) {
        return
      }
      // 解密用已登录的 certId（私钥需认证），因此加密也必须用同一 certId，确保加解密一致
      let encryptCertId = this.caForm.certId
      try {
        const lastLoginId = await this.xtxObject.SOF_GetLastLoginCertID()
        if (lastLoginId) encryptCertId = lastLoginId
      } catch (e) { /* fallback to caForm.certId */ }
      if (encryptCertId && encryptCertId !== this.caForm.certId) {
        const matched = this.certList.find(item => item.certid === encryptCertId)
        if (matched) {
          this.caForm.certId = matched.certid
          this.currentCaUserName = matched.name || this.currentCaUserName
        }
      }
      await this.exportExchangeCert(encryptCertId)
      if (!this.asymForm.cert) {
        this.$message.error('导出加密证书失败，无法继续加密')
        return
      }
      try {
        const newCipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.symKey)
        if (newCipher) {
          if (!this.bidKeyInfo) this.bidKeyInfo = {}
          this.bidKeyInfo.secretKey = newCipher
        } else {
          this.$message.error('重新加密对称密钥失败，无法继续')
          return
        }
      } catch (e) {
        console.error('重新加密对称密钥失败:', e)
        this.$message.error('重新加密对称密钥失败：' + (e.message || '未知错误'))
        return
      }

      const loading = this.$loading({ text: '正在加密开标一览表...', spinner: 'el-icon-loading' })
      try {
        const summarySaved = await this.saveOpeningSummaryIfNeeded({ force: true, showSuccess: false })
        if (!summarySaved) {
          try {
            await this.addOpeningSummary('')
          } catch (e) {
            console.warn('更新 secretKey 到后端失败:', e)
          }
        }
        await this.finishBidMakeAndExportKey()
        this.$message.success('开标一览表加密成功')

      } catch (error) {
        this.$message.error('加密失败：' + (error.message || '未知错误'));
      } finally {
        loading.close()
      }
    },

    /******** ----------------明标正文/暗标正文/附件旧加解密逻辑占位----------------- ********/
    async encryptAndUploadAttFiles() {
      this.$message.info('附件加解密逻辑已移除')
    },
    async encryptAndUploadMain() {
      this.$message.info('正文加解密逻辑已移除')
    },
    async getBidMain() {
      try {
        const res = await getBidMain(this.projectInfo.sectionCode, this.currentMainBlindFlag)
        if (res.code !== 200) {
          this.currentMainState.bidMainUrl = ''
          return
        }
        const data = res.data || {}
        if (data.fileId) {
          this.currentMainState.bidMainUrl = data.fileId
          this.currentMainState.bidMainFileInfo = {
            ...data,
            fileName: data.fileName || this.currentMainLabel,
            fileId: data.fileId
          }
          this.currentMainState.mainEncryptSuccess = true
          this.currentMainState.mainEncryptResult = `${this.currentMainLabel}已加密`
        } else {
          this.currentMainState.bidMainUrl = ''
          this.currentMainState.bidMainFileInfo = {}
        }
      } catch (error) {
        console.error('获取投标正文状态失败:', error)
        this.currentMainState.bidMainUrl = ''
        this.currentMainState.bidMainFileInfo = {}
      }
    },
    async downloadBidMainEncrypted(row) {
      if (!row || !row.fileId) {
        this.$message.warning('正文文件信息不完整')
        return
      }
      const loading = this.$loading({ text: '正在获取下载链接...' })
      try {
        const fileUrl = await this.resolveFileUrlByOneTime(row.fileId)
        if (!fileUrl) {
          this.$message.error('获取正文下载链接失败')
          return
        }
        const link = document.createElement('a')
        link.href = fileUrl
        link.download = row.fileName || this.currentMainLabel
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.$message.success('正文下载已开始')
      } catch (error) {
        console.error('下载正文失败:', error)
        this.$message.error('下载失败：' + (error.message || '未知错误'))
      } finally {
        loading.close()
      }
    },
    deleteBidMainEncrypted(row) {
      if (!row || !row.fileId) {
        this.$message.warning('正文文件信息不完整')
        return
      }
      this.$confirm(`确定要删除${this.currentMainLabel}吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteBidMain(row.fileId)
          if (res.code === 200) {
            this.currentMainState.bidMainUrl = ''
            this.currentMainState.bidMainFileInfo = {}
            this.currentMainState.mainEncryptSuccess = false
            this.currentMainState.mainEncryptResult = ''
            this.currentMainState.encryptedMainFilePath = ''
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除正文失败:', error)
          this.$message.error('删除失败：' + (error.message || '未知错误'))
        }
      }).catch(() => {})
    },
    async loadBidAttList() {
      try {
        const res = await getBidAttList(this.projectInfo.sectionCode)
        if (res.code === 200) {
          this.bidAttList = res.data || []
        } else {
          this.$message.error(res.msg || '获取已上传附件列表失败')
        }
      } catch (error) {
        console.error('获取已上传附件列表失败:', error)
        this.$message.error('获取已上传附件列表失败')
      }
    },
    async downloadAndDecryptAtt(att) {
      if (!att || !att.fileId) {
        this.$message.warning('文件信息不完整')
        return
      }
      const loading = this.$loading({ text: '正在获取下载链接...' })
      try {
        const fileUrl = await this.resolveFileUrlByOneTime(att.fileId)
        if (!fileUrl) {
          this.$message.error('获取文件下载链接失败')
          return
        }
        const link = document.createElement('a')
        link.href = fileUrl
        link.download = att.fileName || ''
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.$message.success('附件下载已开始')
      } catch (error) {
        console.error('下载附件失败:', error)
        this.$message.error('下载失败：' + (error.message || '未知错误'))
      } finally {
        loading.close()
      }
    },
    deleteAndDecryptAtt(row) {
      if (!row || !row.fileId) {
        this.$message.warning('文件信息不完整')
        return
      }
      this.$confirm(`确定要删除附件 "${row.fileName}" 吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteBidAtt(row.fileId)
          if (res.code === 200) {
            this.$message.success('删除成功')
            await this.loadBidAttList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除附件失败:', error)
          this.$message.error('删除失败：' + (error.message || '未知错误'))
        }
      }).catch(() => {})
    },

    /******** ----------------通用工具方法----------------- ********/
    // ArrayBuffer 转 base64（O(n) 分块，CHUNK 必须是 3 的倍数）
    arrayBufferToBase64(buffer) {
      const bytes = new Uint8Array(buffer)
      const CHUNK = 6144 // 3 * 2048
      let result = ''
      for (let i = 0; i < bytes.length; i += CHUNK) {
        const end = Math.min(i + CHUNK, bytes.length)
        result += btoa(String.fromCharCode.apply(null, bytes.subarray(i, end)))
      }
      return result
    },
    // 更新 全局 loading 的文案（进度提示）
    updateLoadingText(loadingInstance, text) {
      if (!loadingInstance) return
      try {
        if (loadingInstance.$el) {
          const el = loadingInstance.$el.querySelector('.el-loading-text')
          if (el) {
            el.textContent = text
            return
          }
        }
        if (typeof loadingInstance.setText === 'function') loadingInstance.setText(text)
      } catch (e) { /* ignore */ }
    },
    normalizeEncryptedText(text) {
      if (!text) return ''
      let normalized = String(text).trim()
      if ((normalized.startsWith('"') && normalized.endsWith('"')) || (normalized.startsWith("'") && normalized.endsWith("'"))) {
        normalized = normalized.slice(1, -1)
      }
      normalized = normalized.replace(/\r|\n/g, '')
      return normalized
    },
  }
}
</script>

<style scoped>
.make-bid-document-page {
  position: relative;
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f4f8ff 0%, #eef3fb 100%);
}

.page-shell {
  display: flex;
  min-height: calc(100vh - 120px);
  border-radius: 24px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 24px 60px rgba(31, 45, 61, 0.12);
  backdrop-filter: blur(14px);
}

.left-sidebar {
  width: 320px;
  padding: 28px 20px 24px;
  background: linear-gradient(180deg, #0f172a 0%, #172554 100%);
  color: #fff;
}

.sidebar-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sidebar-kicker {
  margin: 0 0 6px;
  font-size: 12px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.68);
}

.sidebar-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.project-summary-card {
  margin-bottom: 20px;
  padding: 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.document-menu {
  border-right: none;
  background: transparent;
}

.document-menu /deep/ .el-submenu__title,
.document-menu /deep/ .el-menu-item {
  color: rgba(255, 255, 255, 0.78);
  border-radius: 14px;
  margin-bottom: 8px;
}

.document-menu /deep/ .el-submenu__title:hover,
.document-menu /deep/ .el-menu-item:hover,
.document-menu /deep/ .el-menu-item.is-active {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
}

.document-menu /deep/ .el-menu {
  background: transparent;
}

.right-content {
  flex: 1;
  padding: 28px;
  overflow-y: auto;
}

.hero-panel {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
  padding: 28px;
  border-radius: 24px;
  background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 55%, #93c5fd 100%);
  color: #fff;
  box-shadow: 0 20px 40px rgba(37, 99, 235, 0.22);
}

.hero-kicker {
  margin: 0 0 10px;
  font-size: 13px;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.82);
}

.hero-title {
  margin: 0 0 12px;
  font-size: 34px;
  line-height: 1.2;
}

.hero-desc {
  margin: 0;
  max-width: 720px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.metric-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 122px;
  padding: 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.metric-label,
.metric-extra {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.82);
}

.metric-value {
  font-size: 28px;
  font-weight: 700;
}

.toolbar-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 22px 24px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
}

.panel-title {
  margin: 0 0 8px;
  font-size: 24px;
  color: #111827;
}

.panel-subtitle {
  margin: 0;
  color: #6b7280;
}

.toolbar-actions {
  display: flex;
  gap: 12px;
}

.content-panel {
  margin-bottom: 20px;
}

.single-template-card {
  padding: 36px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.menu-display-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
  font-size: 12px;
  margin-bottom: 16px;
}

.menu-display-title {
  margin: 0 0 10px;
  font-size: 30px;
  color: #111827;
}

.menu-display-desc {
  margin: 0 0 26px;
  color: #6b7280;
  line-height: 1.8;
}

.pdf-preview-panel {
  min-height: 780px;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #dbeafe;
  background: #f8fbff;
}

.pdf-viewer-container {
  height: 780px;
  display: flex;
  flex-direction: column;
}

.pdf-viewer-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}

.pdf-viewer-container /deep/ .pdf-viewer {
  flex: 1;
}

.attachment-panel {
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.attachment-table /deep/ .el-table__header-wrapper th {
  background: #f8fafc;
  color: #334155;
}

.inline-upload {
  display: inline-block;
  margin: 0 10px;
  vertical-align: middle;
}

.opening-summary-panel {
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.opening-summary-table /deep/ .el-table__header-wrapper th {
  background: #f8fafc;
  color: #334155;
}

.opening-summary-table .empty-value {
  color: #9ca3af;
  font-style: italic;
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.content-title {
  margin: 0 0 20px;
  font-size: 20px;
  color: #111827;
  font-weight: 600;
}

.content-body {
  margin-bottom: 20px;
}


.file-link {
  color: #2563eb;
  text-decoration: none;
}

.file-link:hover {
  text-decoration: underline;
}

.bid-att-panel,
.bid-main-panel .bid-sign-panel,
.encrypt-upload-panel {
  padding: 20px 0;
}

/* 投标正文预览区域 */
.main-preview-section {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 760px;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.preview-header .section-title {
  margin: 0;
}

.preview-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.panel-header-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.panel-header-actions .content-title,
.panel-header-actions .section-title {
  margin: 0;
}

.main-pdf-viewer {
  min-height: 280px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  overflow: visible;
}

.main-workflow-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.blind-encrypt-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  margin-bottom: 16px;
  padding: 28px;
  border: 1px dashed #bfdbfe;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
  text-align: center;
}

.blind-encrypt-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #dbeafe;
  color: #2563eb;
  font-size: 26px;
}

.blind-encrypt-card h4 {
  margin: 0 0 8px;
  color: #0f172a;
  font-size: 18px;
}

.blind-encrypt-card p {
  margin: 0 0 18px;
  color: #64748b;
}

.blind-file-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  max-width: 100%;
}

.blind-file-row .el-tag {
  max-width: 760px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.workflow-card {
  display: flex;
  flex-direction: column;
  height: 620px;
  max-height: 620px;
  padding: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  overflow: hidden;
}

.workflow-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  font-weight: 700;
  color: #1f2937;
}

.path-row {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.path-row .el-input {
  flex: 1;
}

.main-original-viewer,
.main-signed-viewer {
  flex: 1;
  min-height: 0;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.main-original-viewer /deep/ .pdf-viewer,
.main-signed-viewer /deep/ .pdf-viewer {
  min-height: 100%;
}

.workflow-encrypt-form {
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.encrypt-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 0;
}
.encrypt-divider {
  display: flex;
  align-items: center;
  color: #c0c4cc;
  font-size: 12px;
  margin: 2px 0;
}
.encrypt-divider::before,
.encrypt-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #e4e7ed;
}
.encrypt-divider span {
  padding: 0 8px;
}

.main-file-encrypt-form {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f8fafc;
}

.main-file-encrypt-form .el-input {
  flex: 1;
}

.empty-encrypt-form {
  margin-top: 16px;
}

.pdf-chapters {
  width: 260px;
  min-width: 260px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chapter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 14px 11px;
  background: linear-gradient(135deg, #f0f7ff 0%, #f8fafc 100%);
  border-bottom: 1px solid #e8f0fe;
  flex-shrink: 0;
}

.chapter-header-left {
  display: flex;
  align-items: center;
  gap: 7px;
}

.chapter-icon {
  font-size: 15px;
  color: #3b82f6;
}

.chapter-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: 0.3px;
}

.chapter-count-badge {
  height: 18px;
  min-width: 18px;
  padding: 0 5px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 700;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.catalogue-tree {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 6px 6px 10px;
  background: transparent;
}

.catalogue-tree /deep/ .el-tree-node__content {
  height: auto !important;
  min-height: 34px;
  border-radius: 8px;
  padding: 3px 6px 3px 2px;
  margin-bottom: 2px;
  transition: background 0.15s ease;
}

.catalogue-tree /deep/ .el-tree-node__content:hover {
  background: #eff6ff;
}

.catalogue-tree /deep/ .el-tree-node.is-current>.el-tree-node__content {
  background: linear-gradient(120deg, #3b82f6 0%, #2563eb 100%);
}

.catalogue-tree /deep/ .el-tree-node.is-current>.el-tree-node__content .catalogue-node-title {
  color: #fff;
  font-weight: 600;
}

.catalogue-tree /deep/ .el-tree-node.is-current>.el-tree-node__content .node-type-icon {
  color: rgba(255, 255, 255, 0.85);
}

.catalogue-tree /deep/ .el-tree-node.is-current>.el-tree-node__content .node-meta {
  opacity: 1;
}

.catalogue-tree /deep/ .el-tree-node.is-current>.el-tree-node__content .catalogue-node-tag {
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
}

.catalogue-tree /deep/ .el-tree-node.is-current>.el-tree-node__content .catalogue-node-action {
  color: rgba(255, 255, 255, 0.9);
}

.catalogue-tree /deep/ .el-tree-node__expand-icon {
  color: #94a3b8;
  font-size: 12px;
}

.catalogue-tree::-webkit-scrollbar {
  width: 4px;
}

.catalogue-tree::-webkit-scrollbar-track {
  background: transparent;
}

.catalogue-tree::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.catalogue-tree::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  padding-right: 2px;
}

.node-type-icon {
  flex-shrink: 0;
  font-size: 13px;
  color: #64748b;
  transition: color 0.15s;
}

.catalogue-node-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  color: #374151;
  line-height: 1.4;
  transition: color 0.15s;
}

.node-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  opacity: 1;
}

.catalogue-node-tag {
  flex-shrink: 0;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1;
}

.catalogue-node-action {
  flex-shrink: 0;
  font-size: 11px;
  padding: 0;
  height: auto;
  line-height: 1;
  color: #3b82f6;
  min-width: 26px;
  text-align: center;
}

.pdf-viewer-panel {
  flex: 1;
  min-height: 600px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.pdf-viewer-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.pdf-viewer-scroll /deep/ .pdf-viewer {
  min-height: 100%;
}

.no-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  color: #94a3b8;
}

.no-preview i {
  font-size: 48px;
  margin-bottom: 16px;
}

.upload-empty-state {
  padding: 40px 0;
}

.encrypt-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  margin: 8px 12px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.encrypt-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.encrypt-btn i {
  font-size: 16px;
}

.encrypt-notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px;
  text-align: center;
}

.encrypt-notice i {
  font-size: 64px;
  color: #3b82f6;
  margin-bottom: 24px;
}

.encrypt-notice h3 {
  margin: 0 0 12px;
  font-size: 24px;
  color: #1e293b;
}

.encrypt-notice p {
  margin: 0 0 24px;
  color: #64748b;
}

/* 隐藏 el-upload 默认文件列表 */
.hide-file-list /deep/ .el-upload-list {
  display: none;
}

.ca-status-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.ca-status-title {
  margin: 4px 0 0;
  font-size: 16px;
  color: white;
}

.ca-status-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.ca-status-row span {
  font-size: 12px;
  color: white;
}

.ca-status-row strong {
  font-size: 13px;
  color: white;
  word-break: break-all;
}

.ca-lock-panel {
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
}

.ca-lock-line {
  margin-bottom: 6px;
  color: white;
  font-size: 12px;
  word-break: break-all;
}

.ca-user-select {
  width: 100%;
  margin: 8px 0 12px;
}

.unlock-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 20px;
  left: 350px;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(4px);
}

.unlock-overlay-card {
  width: 100%;
  max-width: 560px;
  padding: 32px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.28);
  text-align: center;
}

.unlock-overlay-icon {
  font-size: 52px;
  margin-bottom: 40px;
}

.unlock-overlay-card h2 {
  margin: 0 0 12px;
  color: #0f172a;
}

.unlock-overlay-card p {
  margin: 0 0 20px;
  color: #475569;
}

.unlock-overlay-info {
  margin-bottom: 20px;
  padding: 16px;
  border-radius: 12px;
  background: #f8fafc;
  text-align: left;
}

.unlock-overlay-line {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.unlock-overlay-line:last-child {
  margin-bottom: 0;
}

.unlock-overlay-divider {
  height: 1px;
  margin: 16px 0;
  background: #e2e8f0;
}

.unlock-overlay-line span {
  font-size: 12px;
  color: #64748b;
}

.unlock-overlay-line strong {
  color: #0f172a;
  word-break: break-all;
}

.unlock-overlay-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.unlock-step-panel {
  margin-bottom: 20px;
  padding: 14px 16px;
  border-radius: 12px;
  text-align: left;
  background: #f8fafc;
}

.unlock-step-panel.is-loading {
  background: #eff6ff;
}

.unlock-step-panel.is-success {
  background: #ecfdf5;
}

.unlock-step-panel.is-error {
  background: #fef2f2;
}

.unlock-step-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  color: #64748b;
}

.unlock-step-panel strong {
  color: #0f172a;
}

.ca-action-group {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.ca-action-group .el-button {
  flex: 1;
}

.upload-section {
  margin-bottom: 24px;
}

.section-title {
  margin: 0 0 16px;
  font-size: 16px;
  color: #374151;
  font-weight: 500;
}

.att-uploader,
.main-uploader {
  padding: 20px;
  background: #f9fafb;
  border-radius: 12px;
  border: 2px dashed #d1d5db;
}

.existing-files,
.existing-main {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.main-file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f3f4f6;
  border-radius: 8px;
  color: #2563eb;
}

.main-file-info i {
  font-size: 18px;
}

.bid-att-table /deep/ .el-table__header-wrapper th,
.bid-sign-table /deep/ .el-table__header-wrapper th {
  background: #f8fafc;
  color: #334155;
}

.pending-sign-table /deep/ .el-table__header-wrapper th {
  background: #f1f5f9;
  color: #475569;
}

/* 待上传文件列表 */
.pending-files {
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.pending-att-table /deep/ .el-table__header-wrapper th {
  background: #f1f5f9;
  color: #475569;
}

.file-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-name-cell i {
  font-size: 18px;
  color: #64748b;
}

.danger-text {
  color: #ef4444;
}

/* 待上传正文卡片 */
.pending-main-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-info i {
  font-size: 24px;
  color: #3b82f6;
}

.file-name {
  font-weight: 500;
  color: #1e293b;
}

.file-size {
  color: #64748b;
  font-size: 13px;
}

.file-actions {
  display: flex;
  gap: 8px;
}

/* 预览弹窗 */
.preview-container {
  min-height: 400px;
  max-height: 70vh;
}

.preview-frame {
  width: 100%;
  height: 70vh;
  border: none;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  display: block;
  margin: 0 auto;
}

.preview-not-supported {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #64748b;
}

.preview-not-supported i {
  font-size: 48px;
  margin-bottom: 16px;
  color: #94a3b8;
}

.preview-not-supported p {
  margin-bottom: 20px;
}

.download-link {
  text-decoration: none;
}

.template-placeholder {
  display: flex;
  align-items: center;
  gap: 20px;
  min-height: 240px;
  padding: 28px;
  border-radius: 24px;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
  border: 1px dashed #93c5fd;
}

.placeholder-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
  color: #2563eb;
  font-size: 30px;
}

.placeholder-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.placeholder-text strong {
  font-size: 22px;
  color: #111827;
}

.placeholder-text span {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.9;
}

@media (max-width: 1280px) {
  .hero-panel {
    grid-template-columns: 1fr;
  }

  .hero-metrics {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1200px) {
  .page-shell {
    flex-direction: column;
  }

  .left-sidebar {
    width: 100%;
  }

  .unlock-overlay {
    left: 0;
  }

  .content-panel {
    padding: 20px;
  }

  .toolbar-panel {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .toolbar-actions {
    width: 100%;
    flex-wrap: wrap;
  }
}
</style>
